var render = function render(){
  var _vm$mobileTextobject$, _vm$mobileTextobject$2, _vm$blok$afterImages, _vm$blok$afterImages2, _vm$blok$afterImages3, _vm$blok$afterImages4, _vm$blok$afterImages5, _vm$blok$afterImages6, _vm$blok$afterImages7, _vm$blok$afterImages8, _vm$blok$afterImages9, _vm$blok$afterImages0, _vm$blok$afterImages1, _vm$blok$afterImages10, _vm$blok$afterImages11, _vm$blok$afterImages12, _vm$blok$beforeImages, _vm$blok$beforeImages2, _vm$blok$beforeImages3, _vm$blok$beforeImages4, _vm$blok$beforeImages5, _vm$blok$beforeImages6, _vm$blok$beforeImages7, _vm$blok$beforeImages8, _vm$blok$beforeImages9, _vm$blok$beforeImages0, _vm$blok$beforeImages1, _vm$blok$beforeImages10, _vm$blok$beforeImages11, _vm$blok$beforeImages12, _vm$blok$staticImage;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "editable",
      rawName: "v-editable",
      value: _vm.blok,
      expression: "blok"
    }],
    ref: "container",
    staticClass: "RechargeDifference relative w-full py-12 md:py-0",
    class: [_vm.blok.classes, _vm.blok.toggleStaticImage ? 'h-full ' : 'h-full md:h-screen'],
    style: {
      willChange: 'transform'
    },
    attrs: {
      "id": _vm.blok.id
    }
  }, [_c('div', {
    staticClass: "w-full flex justify-center text-8xl h-full"
  }, [_c('aside', {
    staticClass: "flex justify-start items-center w-full md:w-1/3 h-full"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('svg', {
    ref: "topLine",
    staticClass: "hidden md:block absolute top-[calc(50%-156px)] left-0 -translate-y-1/2 z-50 w-full pointer-events-none opacity-0",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "962",
      "height": "2",
      "viewBox": "0 0 962 2",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1.00012L961 1.00004",
      "stroke": "#80C9C6",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('svg', {
    ref: "bottomLine",
    staticClass: "hidden md:block absolute top-1/2 left-0 -translate-y-1/2 z-50 w-full pointer-events-none",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "962",
      "height": "2",
      "viewBox": "0 0 962 2",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1.00012L961 1.00004",
      "stroke": "#80C9C6",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col pointer-events-auto"
  }, [_vm._l(_vm.blok.aboveContent, function (aboveBlock) {
    return _c('StoryblokComponent', {
      key: aboveBlock._uid,
      attrs: {
        "blok": aboveBlock
      }
    });
  }), _vm._v(" "), _c('div', {
    staticClass: "md:hidden pointer-events-auto",
    style: `
              width: calc(100% + 64px);
              margin-left: -32px;
              overflow: hidden;
              -webkit-mask: linear-gradient( 90deg, transparent, white 20%, white 80%, transparent );
              mask: linear-gradient(90deg, transparent, white 20%, white 80%, transparent);
            `
  }, [_c('div', {
    ref: "swiper",
    staticClass: "swiper w-full px-8"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(0);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 0 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24225)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3407 107.692 107.693 86.3397 107.693 60C107.693 33.6603 86.3407 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6603 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.5126 70.0744C75.4494 68.049 72.5246 66.4732 69.0179 65.2791C56.5743 61.0355 36.4332 61.9575 21.1555 63.8167C19.7196 63.9905 19.8254 66.1067 21.2689 66.1369C32.4844 66.3598 43.0877 67.5539 52.0321 69.7267C56.8161 70.8906 60.1377 73.0445 62.2085 75.5461C62.2349 75.5726 62.2538 75.5915 62.2614 75.6141C62.8887 76.3245 63.4139 77.1256 63.8182 78.0061C64.1924 78.8374 64.4606 79.7368 64.5891 80.6853C65.3222 85.9945 61.6114 90.8843 56.3098 91.6174C53.9178 91.9461 51.6089 91.3831 49.7309 90.1701C53.9027 98.1698 64.0601 102.243 73.5033 97.3649C77.8565 95.1165 81.008 90.9939 82.0019 86.1948C83.1544 80.6437 81.8167 75.6179 78.9977 71.8202C78.5404 71.208 78.0454 70.6223 77.5089 70.0706L77.5126 70.0744Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.189 60.1359C53.9286 55.658 71.9006 51.0781 76.2765 37.7805C76.813 36.1669 77.0889 33.8165 76.7979 31.7042C75.7172 23.8707 68.0538 18.5464 60.1561 20.5416C60.1485 20.5416 60.1448 20.5454 60.1372 20.5491C59.6233 20.6814 59.1093 20.8401 58.5954 21.0328C58.1495 21.2029 57.7225 21.3994 57.3031 21.611C57.1142 21.7017 56.929 21.7999 56.7438 21.902C56.7401 21.902 56.7325 21.9095 56.7287 21.9095C55.391 22.6426 54.1893 23.6138 53.1086 24.9552C52.8592 25.2575 52.6174 25.5712 52.3944 25.8962C52.1753 26.2174 51.9787 26.5461 51.786 26.8862C51.7558 26.9353 51.7293 26.9807 51.6991 27.0298C48.6042 32.4373 50.5163 38.0639 50.5163 38.0639C50.5163 38.0639 50.1384 34.3645 52.2168 31.9763C53.0292 31.1298 54.076 30.5025 55.2739 30.1964C55.7765 30.0793 56.3281 30.0075 56.9403 29.9924C59.8046 30.0075 62.3667 31.9989 63.0998 34.7612C63.4285 36.0082 63.3756 37.2439 63.0242 38.3549C62.8277 38.9784 62.5518 39.5565 62.1928 40.0818C62.1664 40.1082 62.155 40.1309 62.1362 40.1574C61.0365 41.9447 59.2756 43.6074 56.8647 45.2096C53.1691 47.6659 47.943 49.952 41.262 52.1929C43.5595 49.8198 44.3834 46.075 42.5166 42.5456C41.5115 40.6486 39.7505 39.2429 37.6609 38.7328C32.0569 37.3648 27.4429 41.4875 27.3749 46.4302C27.3976 44.8431 29.2568 43.4147 30.6323 43.0746C32.6199 42.5796 34.6869 43.426 35.6354 45.2701C36.1493 46.2677 36.2665 47.4618 35.9566 48.5425C35.2084 51.1612 32.2232 53.1602 30.005 54.4677C27.2427 56.1001 24.1856 57.1318 21.0795 57.8989C20.9737 57.9253 20.8754 57.9518 20.7696 57.9782C19.4205 58.3145 19.8022 60.3286 21.189 60.1435V60.1359Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.102 49.4004C76.4016 50.4774 73.4465 52.1212 70.8278 53.1225C65.9116 55.0157 59.892 56.4063 55.6937 57.2452C55.0173 57.3813 55.1156 58.3789 55.8071 58.3789C60.5873 58.3713 73.7375 56.9543 81.1855 53.969C81.1931 53.9614 81.2007 53.9614 81.2082 53.9577C86.2152 51.9549 89.4649 48.2025 89.3931 43.0142C89.3251 38.2227 84.4202 33.042 80.1955 32.9891C82.0169 34.0018 87.7531 43.3014 78.1058 49.408L78.102 49.4004Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M91.5753 47.1331C95.6564 48.9394 96.4576 55.2386 88.7941 57.2641C82.049 59.0439 75.5154 59.8488 70.9128 60.2078C70.1382 60.2682 70.0815 61.4472 70.8562 61.5152C77.265 62.0745 84.1009 62.5128 86.901 63.741C91.8776 65.9176 90.06 72.2319 86.3379 73.1048C86.3379 73.1048 95.0178 73.6906 96.4084 67.516C97.3796 63.2195 93.2229 60.7897 93.2229 60.7897C102.477 57.9669 100.384 46.3396 91.5753 47.1407V47.1331Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.9858 76.1318C45.769 75.1266 44.2613 74.5901 42.7875 74.0799C38.1887 72.4777 30.9145 71.1173 24.2487 70.5241C23.6403 70.4712 23.5043 71.3592 24.1014 71.4877C31.5758 73.1012 42.198 76.6079 42.3378 80.8667C42.4965 85.6468 34.0849 83.7537 34.0849 83.7537C34.9881 84.9893 37.1004 86.6369 38.4797 87.302C42.0658 89.0327 47.0803 88.3789 48.947 84.4679C50.2583 81.7207 49.306 78.059 46.982 76.1356L46.9858 76.1318Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24225",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(1);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 1 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24235)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3406 107.692 107.693 86.3397 107.693 60C107.693 33.6603 86.3406 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6603 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3406 107.692 107.693 86.3397 107.693 60C107.693 33.6603 86.3406 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6603 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.7824 43.6379C89.7824 42.5609 89.3365 41.4802 88.4485 40.7018C86.884 39.3301 84.4807 39.5303 83.0108 41.0041L73.4617 50.5531C72.9553 51.0595 72.1354 51.0595 71.6328 50.5531L71.5118 50.4322C71.0055 49.9258 71.0055 49.1058 71.5118 48.6032L73.2274 46.8877L73.3824 46.7327L85.5577 34.5574C86.3172 33.7979 86.6989 32.8003 86.6989 31.8027C86.6989 30.7257 86.253 29.645 85.3649 28.8665C83.8005 27.4948 81.401 27.6951 79.931 29.1651L66.7959 42.3002C66.2895 42.8066 65.4695 42.8066 64.967 42.3002L64.846 42.1793C64.3397 41.6729 64.3397 40.8529 64.846 40.3503L75.1622 30.0342C75.9217 29.2746 76.3034 28.277 76.3034 27.2794C76.3034 26.2025 75.8575 25.1217 74.9694 24.3433C73.405 22.9716 71.0017 23.1719 69.5318 24.6418L60.8329 33.3406L58.0631 36.1105L50.5055 43.6681C50.0747 44.0989 49.368 44.182 48.8957 43.7966C48.3515 43.3507 48.3213 42.5458 48.805 42.0621L54.8057 36.0614C56.4193 34.4478 56.4193 31.8253 54.8057 30.2118C53.1922 28.5982 50.5697 28.5982 48.9562 30.2118L41.4968 37.6712C41.4968 37.6712 42.245 36.9267 42.2299 36.9418C34.9859 44.2841 34.6609 55.8812 41.2512 63.6089L31.3658 73.4942C30.6063 74.2538 30.2246 75.2514 30.2246 76.249C30.2246 77.3259 30.6705 78.4067 31.5585 79.1851C33.123 80.5568 35.5263 80.3565 36.9962 78.8828L46.5453 69.3338C47.0516 68.8274 47.8716 68.8274 48.3742 69.3338L48.4951 69.4547C49.0015 69.9611 49.0015 70.7811 48.4951 71.2836L46.7796 72.9992L46.6246 73.1541L34.4493 85.3295C33.6898 86.089 33.3081 87.0866 33.3081 88.0842C33.3081 89.1612 33.754 90.2419 34.642 91.0203C36.2065 92.392 38.606 92.1918 40.076 90.7218L53.2111 77.5867C53.7174 77.0803 54.5374 77.0803 55.04 77.5867L55.1609 77.7076C55.6673 78.214 55.6673 79.034 55.1609 79.5365L44.8448 89.8527C44.0853 90.6122 43.7036 91.6098 43.7036 92.6074C43.7036 93.6844 44.1495 94.7651 45.0375 95.5436C46.6019 96.9153 49.0053 96.715 50.4752 95.245L59.174 86.5462L61.9439 83.7764L69.5015 76.2188C69.9323 75.788 70.6389 75.7048 71.1113 76.0903C71.6554 76.5362 71.6857 77.3411 71.202 77.8247L65.2012 83.8255C63.5877 85.439 63.5877 88.0615 65.2012 89.6751C66.8148 91.2886 69.4373 91.2886 71.0508 89.6751L78.5102 82.2157C78.5102 82.2157 77.762 82.9601 77.7771 82.945C85.0211 75.6028 85.3461 64.0057 78.7558 56.278L88.6412 46.3926C89.4007 45.6331 89.7824 44.6355 89.7824 43.6379ZM60.0016 69.9611C54.5034 69.9611 50.0444 65.5021 50.0444 60.0039C50.0444 54.5057 54.5034 50.0467 60.0016 50.0467C65.4998 50.0467 69.9588 54.5057 69.9588 60.0039C69.9588 65.5021 65.4998 69.9611 60.0016 69.9611Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24235",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(2);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 2 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24241)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3406 107.692 107.693 86.3397 107.693 60C107.693 33.6602 86.3406 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6602 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.5016 21.2481C65.5405 20.6808 63.1201 22.8742 62.7684 25.8694C62.2428 30.3735 62.2957 38.4439 62.7684 42.7741C62.9878 44.7709 64.2396 46.5786 66.2401 46.7715C68.5357 46.9908 70.4682 45.1907 70.4682 42.9405C70.4682 39.5671 68.5016 37.0333 69.1143 33.8679C69.7232 30.6988 75.9064 28.252 77.9221 30.9673C79.1588 32.6351 77.8049 34.3596 75.7552 35.1802C73.4974 36.0841 72.7259 38.3418 73.6487 40.2062C74.5261 41.9761 76.7346 42.6152 78.4591 41.9761C80.9778 41.2349 84.3512 42.1085 85.0395 45.3381C85.9849 49.7855 81.8817 52.5198 76.4397 50.9579C71.7011 49.5965 69.5227 49.4414 66.9965 49.6267C64.3341 49.8574 62.3146 52.3345 62.8592 55.1557C63.1769 56.8083 64.4362 58.1698 66.0473 58.6577C67.5108 59.1001 68.9933 58.6879 70.3018 57.9845C72.499 56.8046 74.3445 55.4469 76.9842 56.018C78.8071 56.4113 80.0399 57.4853 81.3673 58.703C82.517 59.7619 83.8104 61.1196 85.4706 61.2368C86.8358 61.3314 88.1595 60.5561 89.5247 60.9078C90.6403 61.1952 91.4458 62.1899 91.4458 63.3471C91.4458 66.8226 87.6754 68.8421 84.2907 67.6659C82.9784 67.2083 81.9081 66.4066 81.1896 65.2115C80.6148 64.2509 80.2593 63.1656 79.5483 62.2882C78.5499 61.0553 76.8859 60.3481 75.3051 60.5599C72.5179 60.9343 71.1414 64.3228 72.8205 66.5541C73.8113 67.8739 75.3694 68.1538 76.7346 68.9101C77.9448 69.5833 78.8071 70.6044 78.2776 72.0414C77.8276 73.2592 76.3451 73.8302 74.7605 73.4785C72.4536 72.9642 70.419 70.4266 69.4282 69.1975C68.5924 68.237 67.299 67.6735 65.8695 67.9495C64.3871 68.2332 62.5491 70.1241 63.0407 75.0215C63.6723 81.3485 65.2417 83.1259 67.5978 83.1259C69.1672 83.1259 70.1089 81.8288 70.1089 80.4522C70.124 80.403 70.1354 80.369 70.1354 80.369C70.1959 78.4592 70.4304 77.6536 71.0128 77.1393C71.6103 76.6061 72.5936 76.6061 73.2932 76.92C74.2273 77.3435 74.3408 78.2852 74.2122 79.208C74.0533 80.3349 73.8567 81.5186 74.908 82.275C75.498 82.6986 76.001 82.7326 76.001 82.7326C78.6482 83.1448 78.3305 79.4538 79.9227 79.1361C81.8212 78.7579 83.2393 80.437 82.8158 83.1183C82.3922 85.7996 79.6958 89.5361 72.5784 87.7208C70.211 87.1157 68.6756 86.9001 66.8187 87.1989C64.3228 87.6036 62.0272 90.1109 62.4016 93.2309C62.7609 96.2336 64.7312 97.2396 68.5243 97.2396C87.0438 97.2396 97.3417 79.7488 97.3417 59.24C97.3417 38.7313 86.7224 24.75 68.5092 21.2481H68.5016Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.24 87.1988C51.3831 86.9 49.8477 87.1156 47.4803 87.7207C40.3592 89.5359 37.6665 85.7995 37.2429 83.1182C36.8194 80.4369 38.2376 78.7578 40.136 79.136C41.7282 79.4537 41.4105 83.1447 44.0577 82.7325C44.0577 82.7325 44.5607 82.6984 45.1507 82.2749C46.202 81.5185 46.0054 80.3348 45.8465 79.2078C45.718 78.2813 45.8314 77.3396 46.7655 76.9198C47.4652 76.6022 48.4484 76.606 49.0459 77.1392C49.6283 77.6573 49.8628 78.459 49.9233 80.3689C49.9233 80.3689 49.9347 80.4029 49.9498 80.4521C49.9498 81.8286 50.8915 83.1258 52.4609 83.1258C54.8208 83.1258 56.3864 81.3483 57.018 75.0214C57.5058 70.1239 55.6717 68.2331 54.1892 67.9494C52.7597 67.6771 51.4663 68.2406 50.6305 69.1974C49.6435 70.4265 47.6051 72.9641 45.2982 73.4784C43.7136 73.8301 42.2311 73.2591 41.7811 72.0413C41.2517 70.6042 42.1139 69.5794 43.3241 68.91C44.6893 68.1536 46.2436 67.8738 47.2382 66.5539C48.9174 64.3227 47.5408 60.9304 44.7536 60.5598C43.1728 60.348 41.5088 61.059 40.5104 62.2881C39.7994 63.1654 39.4439 64.2546 38.8691 65.2114C38.1506 66.4064 37.0803 67.2082 35.768 67.6658C32.3795 68.8419 28.6129 66.8224 28.6129 63.347C28.6129 62.1897 29.4146 61.1951 30.534 60.9077C31.8993 60.556 33.2191 61.3313 34.5881 61.2367C36.2483 61.1195 37.5417 59.7656 38.6914 58.7029C40.015 57.4852 41.2517 56.4111 43.0745 56.0178C45.7142 55.4468 47.5635 56.8044 49.7569 57.9844C51.0654 58.6878 52.5479 59.1 54.0115 58.6575C55.6225 58.1697 56.8781 56.8082 57.1995 55.1556C57.7441 52.3343 55.7246 49.8573 53.0622 49.6266C50.536 49.4413 48.3577 49.5963 43.6191 50.9578C38.1771 52.5197 34.0738 49.7892 35.0192 45.338C35.7037 42.1084 39.0809 41.2385 41.5996 41.976C43.3241 42.6113 45.5364 41.976 46.41 40.2061C47.3328 38.3417 46.5613 36.0839 44.3036 35.1801C42.2538 34.3594 40.8999 32.6349 42.1366 30.9672C44.1523 28.2518 50.3355 30.6987 50.9444 33.8678C51.5533 37.037 49.5905 39.567 49.5905 42.9404C49.5905 45.1905 51.523 46.9907 53.8186 46.7713C55.8192 46.5822 57.0709 44.7745 57.2903 42.774C57.763 38.4476 57.816 30.3772 57.2903 25.8693C56.9386 22.8741 54.5182 20.6769 51.5571 21.2479C33.3439 24.7461 22.7246 38.5421 22.7246 59.2399C22.7246 79.9377 33.0225 97.2395 51.5419 97.2395C55.3351 97.2395 57.3016 96.2335 57.6647 93.2308C58.0391 90.1108 55.7473 87.6034 53.2475 87.1988H53.24Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24241",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(3);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 3 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24247)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 108.462C86.3406 108.462 107.693 87.1089 107.693 60.7692C107.693 34.4295 86.3406 13.0769 60.0009 13.0769C33.6612 13.0769 12.3086 34.4295 12.3086 60.7692C12.3086 87.1089 33.6612 108.462 60.0009 108.462Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60.0009 108.462C86.3406 108.462 107.693 87.1089 107.693 60.7692C107.693 34.4295 86.3406 13.0769 60.0009 13.0769C33.6612 13.0769 12.3086 34.4295 12.3086 60.7692C12.3086 87.1089 33.6612 108.462 60.0009 108.462Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.9781 82.6975H77.3594C76.0406 82.6975 74.7747 82.6975 73.6221 82.6975H69.2009C66.8656 82.6975 65.014 81.7377 65.014 78.4426C65.014 74.4333 65.936 73.0238 68.6794 72.7517C69.6884 72.6497 70.7049 72.7857 71.7025 72.9784C73.248 73.2769 74.7898 73.4999 76.3353 73.7757C77.9224 74.0592 79.5246 74.3123 81.1419 74.3086C83.6057 74.301 86.0582 73.7115 88.1252 72.3398C91.4354 70.1443 93.4722 66.358 93.4722 62.3826V59.6241C93.4722 57.0659 90.827 55.1198 88.1063 56.397C85.6765 57.5344 86.7497 60.5688 85.1399 62.1975C83.8551 63.4974 81.4858 63.6221 80.1179 62.3675C78.8293 61.1885 79.2866 59.2765 78.4854 57.8481C77.0155 55.2331 72.7681 55.4788 71.8876 58.464C71.6685 59.2047 71.7063 59.9982 71.4909 60.7389C71.0261 62.3335 69.4352 63.35 67.8028 63.2367C66.8656 63.1724 65.9549 62.7341 65.3465 62.0199C64.7835 61.3624 64.4963 60.5046 64.3867 59.6468C64.1751 57.9879 64.4774 55.8189 65.5922 54.4887C67.2284 52.5351 70.7918 52.3197 72.6547 52.3197H77.0117C79.5548 52.3197 81.6181 50.2565 81.6181 47.7133V41.6672C81.6181 38.6706 78.4968 36.5885 75.9385 38.1718C73.675 39.5738 74.6084 43.0012 72.5792 44.8112C69.0876 47.9287 64.3527 44.5353 63.9975 41.5765C63.3627 36.2787 68.3356 38.2247 71.6118 36.3278C72.7265 35.6854 73.2556 34.6575 73.2027 32.5792C73.1762 31.5022 72.9722 28.2676 72.9722 28.2676C72.9722 25.5166 70.7389 24.5681 68.9818 25.0027C67.7839 25.2974 67.217 26.2799 67.1037 27.3078L66.9072 29.1632C66.8089 30.0776 65.97 30.7616 65.0594 30.6822C63.8766 30.5764 63.5516 29.7791 63.3551 28.6908C63.2077 27.8821 63.0755 24.4812 62.9697 23.442C62.8299 22.0817 61.6471 20.7175 59.9958 20.7175C58.3444 20.7175 57.1616 22.0817 57.0218 23.442C56.916 24.4774 56.7838 27.8821 56.6364 28.6908C56.4361 29.7791 56.1149 30.5764 54.9322 30.6822C54.0215 30.7616 53.1826 30.0776 53.0843 29.1632L52.8878 27.3078C52.7745 26.2799 52.2076 25.2974 51.0098 25.0027C49.2526 24.5681 47.0193 25.5166 47.0193 28.2676C47.0193 28.2676 46.8153 31.4985 46.7888 32.5792C46.7359 34.6575 47.265 35.6854 48.3797 36.3278C51.6559 38.221 56.6288 36.2787 55.994 41.5765C55.6388 44.5353 50.9039 47.9287 47.4123 44.8112C45.3831 43.0012 46.3165 39.5738 44.053 38.1718C41.4947 36.5847 38.3734 38.6669 38.3734 41.6672V47.7133C38.3734 50.2565 40.4367 52.3197 42.9798 52.3197H47.3368C49.1997 52.3197 52.7631 52.5351 54.3993 54.4887C55.5141 55.8189 55.8164 57.9879 55.6048 59.6468C55.4952 60.5046 55.208 61.3624 54.645 62.0199C54.0366 62.7341 53.1259 63.1724 52.1887 63.2367C50.5563 63.35 48.9654 62.3297 48.5006 60.7389C48.2852 59.9982 48.323 59.2047 48.1039 58.464C47.2234 55.4788 42.976 55.2331 41.5061 57.8481C40.705 59.2765 41.1584 61.1848 39.8736 62.3675C38.5057 63.6221 36.1364 63.4974 34.8516 62.1975C33.2418 60.565 34.315 57.5344 31.8852 56.397C29.1645 55.1198 26.5193 57.0659 26.5193 59.6241V62.3826C26.5193 66.358 28.5561 70.1405 31.8663 72.3398C33.9333 73.7115 36.3858 74.3048 38.8496 74.3086C40.4669 74.3123 42.0691 74.0592 43.6562 73.7757C45.2017 73.4999 46.7435 73.2769 48.289 72.9784C49.2866 72.7857 50.3031 72.6497 51.3121 72.7517C54.0592 73.0238 54.9775 74.4333 54.9775 78.4426C54.9775 81.7415 53.1259 82.6975 50.7906 82.6975H46.3694C45.2168 82.6975 43.9509 82.6975 42.6321 82.6975H40.0134C33.4459 82.6899 26.5911 82.6635 26.4551 82.6635C33.6084 93.5956 45.9499 100.824 59.992 100.824C74.034 100.824 86.3756 93.5956 93.5289 82.6635C93.3928 82.6635 86.5381 82.6862 79.9743 82.6975H79.9781Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24247",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(4);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 4 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24255)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3406 107.692 107.693 86.3397 107.693 60C107.693 33.6603 86.3406 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6603 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52.6319 65.3737C54.2265 65.0865 55.8174 64.8976 57.4007 64.7993C57.4007 64.7993 57.669 64.7993 57.8731 64.7993L55.4735 19.9638C52.7792 20.2623 50.1643 20.8292 47.659 21.6303C45.9925 22.2198 44.379 22.8962 42.875 23.6028L52.6281 65.3699L52.6319 65.3737Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.988 69.8327L22.8322 44.5563C20.9579 49.0493 19.8847 53.9542 19.7676 59.0971C19.7676 59.0971 19.7676 59.1047 19.7714 59.1047L35.9069 72.3267C37.1992 71.4274 38.5634 70.5998 39.9842 69.8327H39.988Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.6534 66.2958L35.8923 27.8011C35.8923 27.8011 35.8923 27.8011 35.8886 27.8011C32.5216 30.3215 29.5742 33.3673 27.1406 36.7984C27.1406 36.7984 27.1406 36.8022 27.1406 36.806L43.7749 68.0114C45.396 67.3312 47.0247 66.7606 48.6571 66.2958H48.6534Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M60 71.0005C47.2314 70.9854 36.2955 77.0919 29.4219 86.1989C36.1104 94.0097 45.735 99.232 56.5915 100.146C56.9543 100.177 57.3132 100.203 57.6798 100.222C57.6949 100.222 57.7138 100.222 57.7289 100.222C58.0917 100.241 58.4544 100.256 58.821 100.267C58.8323 100.267 58.8474 100.267 58.8588 100.267C59.2329 100.279 59.607 100.282 59.9849 100.282C60.0755 100.282 60.1662 100.282 60.2569 100.282C60.5214 100.282 60.786 100.279 61.0505 100.271C61.2659 100.267 61.4813 100.256 61.6929 100.248C61.8289 100.241 61.9687 100.237 62.1048 100.23C62.3466 100.218 62.5922 100.199 62.8341 100.184C62.9399 100.177 63.0457 100.169 63.1477 100.162C63.4085 100.143 63.6654 100.116 63.9224 100.094C64.0055 100.086 64.0924 100.078 64.1756 100.067C64.4476 100.041 64.7197 100.007 64.9918 99.9726C65.056 99.9651 65.1203 99.9575 65.1845 99.9462C65.4717 99.9084 65.7589 99.8706 66.0461 99.8252C66.0876 99.8177 66.1292 99.8139 66.167 99.8064C66.4768 99.7572 66.7829 99.7081 67.089 99.6552C67.0966 99.6552 67.1003 99.6552 67.1079 99.6552C70.078 99.1224 72.9348 98.2684 75.6404 97.1234L75.6556 97.1158C75.9503 96.9911 76.2451 96.8627 76.536 96.7304C76.5436 96.7266 76.5549 96.7228 76.5625 96.7191C76.8534 96.5868 77.1444 96.4508 77.4316 96.3147C77.4316 96.3147 77.4316 96.3147 77.4354 96.3147C78.8789 95.6194 80.2733 94.841 81.6147 93.9832C81.6412 93.9681 81.6639 93.953 81.6903 93.9379C81.8868 93.8094 82.0833 93.6809 82.2798 93.5487C82.3705 93.4882 82.4612 93.4277 82.5519 93.3673C82.7182 93.2539 82.8806 93.1405 83.0469 93.0234C83.1678 92.9403 83.2888 92.8571 83.4059 92.7702C83.5495 92.6682 83.6931 92.5624 83.8367 92.4566C83.9765 92.3545 84.1125 92.2525 84.2486 92.1505C84.3733 92.056 84.5018 91.9578 84.6264 91.8633C84.7814 91.7462 84.9325 91.6252 85.0837 91.5043C85.1933 91.4174 85.2991 91.3305 85.4087 91.2436C85.5787 91.1038 85.7488 90.9639 85.9188 90.8204C86.0057 90.7486 86.0926 90.673 86.1795 90.6012C86.376 90.4311 86.5725 90.2573 86.769 90.0835C86.8257 90.0344 86.8824 89.9852 86.9353 89.9361C88.239 88.7571 89.4671 87.4988 90.6121 86.1611C83.5193 76.8841 72.2471 70.8834 60 71.0043V71.0005Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.3624 65.4005L77.123 23.6069C75.7702 22.9683 74.3267 22.3599 72.8341 21.812C70.1776 20.9164 67.3964 20.2967 64.5245 19.9717L62.0531 64.811C61.9662 64.811 62.5973 64.811 62.5973 64.811C64.2033 64.9168 65.7942 65.1133 67.3624 65.4005Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.332 66.3373C72.9909 66.8135 74.6158 67.3916 76.1954 68.068L92.8561 36.806C92.8561 36.806 92.8561 36.8022 92.8561 36.7984C90.4226 33.3635 87.4751 30.3215 84.1082 27.8011C84.1082 27.8011 84.1082 27.8011 84.1044 27.8011L71.332 66.3373Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.2968 75.1498L20.5977 68.295C21.6217 73.1999 23.5413 77.7685 26.1714 81.8383C27.9474 79.4198 29.9918 77.1715 32.3006 75.1498H32.2968Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.6016 75.2061C89.884 77.1938 91.9623 79.427 93.795 81.8644C93.7988 81.8719 93.8101 81.8719 93.8139 81.8644C96.4515 77.787 98.3787 73.2033 99.4028 68.2871L87.6016 75.2023V75.2061Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.1643 44.5563L79.9707 69.8969C81.3613 70.6565 82.7066 71.4916 84.0027 72.4023L100.225 59.1085L100.229 59.1009C100.112 53.9579 99.0386 49.0531 97.1643 44.5601V44.5563Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24255",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(5);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 5 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24269)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3406 107.692 107.693 86.3397 107.693 60C107.693 33.6602 86.3406 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6602 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.393 56.4913C100.188 54.2964 99.6262 51.2508 98.6084 48.1141C97.3097 44.1116 95.5135 40.6027 93.7439 38.0546C92.6502 36.4825 91.4047 35.8445 89.9198 36.3268C88.435 36.8091 87.6224 38.404 88.1047 39.8888L91.6895 50.9242C92.1869 52.4546 91.3515 54.1483 89.7945 54.566C88.3325 54.9609 86.8553 54.1331 86.4034 52.7318L83.8591 44.8976C83.3768 43.4128 81.7819 42.6002 80.2971 43.0825C78.8123 43.5647 77.9996 45.1597 78.4819 46.6445L80.3541 52.409C80.8591 53.9584 80.0085 55.671 78.4363 56.0925C76.9553 56.4913 75.4629 55.6558 75.0034 54.2394L74.3199 52.1318C73.8376 50.647 72.2427 49.8343 70.7579 50.3166C69.2731 50.7989 68.4604 52.3938 68.9427 53.8786L68.9921 54.0267C69.5389 55.7052 68.43 57.4634 66.6832 57.6989L66.5769 57.7141C65.13 57.9077 63.9376 56.6014 64.2604 55.1774L64.3781 54.6571H64.3705L71.1376 26.4116C71.7072 24.0268 71.5553 21.5509 68.3541 20.8293C66.2009 20.3471 63.1326 19.9407 59.8364 19.9407C55.6288 19.9407 51.7364 20.5597 48.7668 21.4597C46.9326 22.0141 45.9415 23.0015 45.9415 24.5622C45.9415 26.123 47.206 27.3875 48.7668 27.3875H60.368C61.9782 27.3875 63.33 28.7053 63.2465 30.3154C63.1705 31.8306 61.9288 32.9736 60.4554 32.9736H52.2186C50.6579 32.9736 49.3934 34.2382 49.3934 35.7989C49.3934 37.3597 50.6579 38.6242 52.2186 38.6242H58.2794C59.9085 38.6242 61.2756 39.9571 61.192 41.5863C61.1123 43.1166 59.8554 44.2787 58.3706 44.2787H56.1566C54.5959 44.2787 53.3313 45.5432 53.3313 47.104C53.3313 48.6647 54.5959 49.9293 56.1566 49.9293H56.3123C58.0743 49.9293 59.4073 51.528 59.0921 53.2596L59.0731 53.366C58.8111 54.8014 57.1971 55.5343 55.9478 54.7862L55.4921 54.5128V54.5204L30.7174 39.3533C28.625 38.0736 26.2212 37.4508 24.5466 40.2761C23.4225 42.1749 22.0858 44.966 21.0681 48.1027C19.7694 52.1052 19.1542 55.9976 19.0934 59.1001C19.0554 61.0141 19.6858 62.2634 21.1706 62.7457C22.6554 63.228 24.2504 62.4153 24.7326 60.9305L28.3175 49.8951C28.8149 48.3647 30.4858 47.4875 31.9896 48.0609C33.4061 48.604 34.1124 50.1381 33.6567 51.5356L31.1124 59.3698C30.6301 60.8546 31.4428 62.4495 32.9276 62.9318C34.4124 63.4141 36.0073 62.6014 36.4896 61.1166L38.3617 55.3521C38.8668 53.8027 40.5567 52.9179 42.0756 53.4989C43.5073 54.0457 44.2212 55.5989 43.7617 57.0153L43.0782 59.1229C42.5959 60.6077 43.4086 62.2027 44.8934 62.6849C46.3782 63.1672 47.9731 62.3546 48.4554 60.8698L48.5048 60.7217C49.0478 59.0432 50.9807 58.2723 52.5339 59.1077L52.6288 59.1571C53.9123 59.8482 54.1098 61.6103 53.0124 62.571L52.6136 62.9204H52.6212L30.5428 81.7976C28.6782 83.3925 27.3453 85.4849 29.5137 87.9494C30.9719 89.6051 33.2162 91.7393 35.882 93.676C39.2845 96.1482 42.801 97.933 45.7326 98.9545C47.5402 99.5849 48.9262 99.3684 49.8414 98.1039C50.7604 96.8431 50.4794 95.0735 49.2149 94.1583L39.8275 87.3381C38.525 86.3925 38.206 84.5317 39.2199 83.2786C40.1731 82.1014 41.8516 81.9039 43.0402 82.7659L49.7009 87.6077C50.9617 88.5267 52.7313 88.2456 53.6465 86.9811C54.5655 85.7165 54.2845 83.9507 53.0199 83.0355L48.1136 79.4735C46.7959 78.5166 46.4769 76.633 47.4984 75.3685C48.463 74.1761 50.1604 73.9748 51.3642 74.852L53.1567 76.1545C54.4174 77.0735 56.187 76.7925 57.1022 75.528C58.0212 74.2672 57.7402 72.4976 56.4756 71.5824L56.3503 71.4913C54.9224 70.4546 54.7857 68.3773 56.0579 67.1622L56.1377 67.0862C57.1933 66.0799 58.9288 66.433 59.5022 67.7773L59.7111 68.2672V68.2596L70.8452 95.0925C71.7832 97.3596 73.3629 99.2735 76.3781 97.9709C78.4021 97.0975 81.1249 95.6203 83.7945 93.6836C87.1971 91.2115 89.9806 88.4203 91.8565 85.9482C93.0148 84.4216 93.2351 83.0393 92.3199 81.7786C91.4009 80.5178 89.6351 80.2368 88.3743 81.152L78.9869 87.9722C77.6844 88.9178 75.8161 88.6444 74.9389 87.2963C74.111 86.0279 74.4414 84.3684 75.6338 83.5026L82.2984 78.6609C83.5591 77.7419 83.8401 75.9761 82.9249 74.7153C82.0059 73.4507 80.2401 73.1735 78.9794 74.0887L74.0731 77.6507C72.7553 78.6077 70.8642 78.3305 69.9756 76.9672C69.1401 75.6836 69.4743 74.0052 70.6781 73.1318L72.4705 71.8292C73.7313 70.9102 74.0123 69.1444 73.0971 67.8837C72.1781 66.6229 70.4123 66.3419 69.1516 67.2571L69.0262 67.3482C67.5984 68.3849 65.5819 67.8761 64.8186 66.2849L64.7731 66.1862C64.1427 64.8723 65.0161 63.3305 66.4667 63.2014L66.9984 63.152H66.9946L95.954 60.8546C98.3996 60.6609 100.708 59.7495 100.405 56.4799L100.393 56.4913Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24269",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide w-[120px] h-[120px]",
    on: {
      "click": function ($event) {
        return _vm.updateIndex(6);
      }
    }
  }, [_c('svg', {
    staticClass: "w-full h-full",
    attrs: {
      "width": "120",
      "height": "120",
      "viewBox": "0 0 120 120",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "#101327"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200",
    class: [_vm.currentIndex === 6 ? 'opacity-0' : 'opacity-100'],
    attrs: {
      "cx": "60",
      "cy": "60",
      "r": "60",
      "transform": "matrix(1 0 0 -1 0 120)",
      "fill": "url(#paint0_linear_3489_24274)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M60.0009 107.692C86.3407 107.692 107.693 86.3397 107.693 60C107.693 33.6602 86.3407 12.3077 60.0009 12.3077C33.6612 12.3077 12.3086 33.6602 12.3086 60C12.3086 86.3397 33.6612 107.692 60.0009 107.692Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_3489_24274)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M99.0245 50.3115C95.6322 35.8612 84.2679 24.4969 69.8176 21.1008C43.4849 14.9214 20.0566 34.7342 20.0566 60.0156C20.0566 66.7926 21.679 71.3232 21.679 71.3232C21.679 54.9971 34.6998 33.5279 60.1135 33.5279C73.9246 33.5279 88.6245 44.6615 88.6245 60.0156C88.6245 77.1207 76.7723 90.8751 60.1135 90.8751C51.6574 90.8751 42.5962 86.8134 42.5962 77.1056C42.5962 66.7623 48.8967 62.349 55.8665 59.263C46.1624 59.6336 35.6301 68.1956 35.6301 79.5789C35.6301 90.9621 46.4271 100.072 60.1173 100.072C85.4024 100.072 105.215 76.6442 99.032 50.3115H99.0245Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.4297 57.2212L60.083 57.5313L52.648 65.1668L58.3094 69.5801L63.9026 60.5076L66.7995 70.7639L73.4517 68.0712L68.3879 58.6886L78.7197 61.3093L79.7106 54.2033L69.0572 53.8932L76.4923 46.2578L70.8347 41.8444L65.2414 50.917L62.3445 40.6607L55.6924 43.3533L60.7524 52.736L50.4205 50.1152L49.4297 57.2212Z",
      "fill": "#FAFAF4"
    }
  })])]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3489_24274",
      "x1": "28.4284",
      "y1": "133.096",
      "x2": "-17.7081",
      "y2": "-41.9099",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip0_3489_24274"
    }
  }, [_c('rect', {
    attrs: {
      "width": "80.1099",
      "height": "80.1099",
      "fill": "white",
      "transform": "translate(20.0566 19.9629)"
    }
  })])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "md:hidden p-6 mt-6 mb-12 bg-[#101327] bg-opacity-60 rounded-xl"
  }, [_c('div', {
    staticClass: "text-white text-lg-semibold"
  }, [_vm._v("\n              " + _vm._s((_vm$mobileTextobject$ = _vm.mobileTextobject[_vm.currentIndex]) === null || _vm$mobileTextobject$ === void 0 ? void 0 : _vm$mobileTextobject$.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-white text-sm-regular"
  }, [_vm._v("\n              " + _vm._s((_vm$mobileTextobject$2 = _vm.mobileTextobject[_vm.currentIndex]) === null || _vm$mobileTextobject$2 === void 0 ? void 0 : _vm$mobileTextobject$2.text) + "\n            ")])]), _vm._v(" "), _vm._l(_vm.blok.belowContent, function (belowBlock) {
    return _c('StoryblokComponent', {
      key: belowBlock._uid,
      attrs: {
        "blok": belowBlock
      }
    });
  })], 2)])]), _vm._v(" "), !_vm.blok.toggleStaticImage ? _c('aside', {
    staticClass: "hidden md:block relative w-4/5 h-full"
  }, [_c('div', {
    staticClass: "absolute h-full w-full flex justify-center items-end"
  }, [_c('div', {
    staticClass: "h-1/2 w-full grid grid-cols-3",
    style: {
      placeItems: 'start end'
    }
  }, [_c('div', {
    staticClass: "RechargeDifference--after flex justify-end relative",
    style: {
      willChange: 'transform'
    },
    on: {
      "mouseenter": _vm.changeZIndex
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto overflow-visible w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1200",
      "viewBox": "0 0 156 1200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    ref: "expanding",
    staticClass: "RechargeDifference--circle group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-20",
      "y": "-20"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3311_24019)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "54"
    }
  }, [_vm._v("EXPANDING PERSPECTIVES")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "83"
    }
  }, [_vm._v("\n                      Inspiring minds with progressive\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "107"
    }
  }, [_vm._v("\n                      programming and fresh perspectives\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "131"
    }
  }, [_vm._v("\n                      that spark market innovation and leave\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "155"
    }
  }, [_vm._v("a lasting impression.")])]), _vm._v(" "), _c('circle', {
    staticClass: "ease-in-out duration-200 opacity-0 group-hover:opacity-100",
    attrs: {
      "cx": "98",
      "cy": "98",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.245 159.49C132.07 159.49 159.49 132.07 159.49 98.245C159.49 64.4203 132.07 37 98.245 37C64.4203 37 37 64.4203 37 98.245C37 132.07 64.4203 159.49 98.245 159.49Z",
      "stroke": "#FAFAF4",
      "stroke-width": "6.11",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.759 51.701C104.241 51.027 101.365 53.6334 100.947 57.1925C100.322 62.5446 100.385 72.1345 100.947 77.2799C101.207 79.6526 102.695 81.8007 105.072 82.0299C107.8 82.2905 110.096 80.1514 110.096 77.4776C110.096 73.4691 107.759 70.4582 108.487 66.6969C109.211 62.9311 116.558 60.0236 118.953 63.2502C120.423 65.2319 118.814 67.2811 116.378 68.2563C113.696 69.3303 112.779 72.0131 113.875 74.2286C114.918 76.3317 117.542 77.0911 119.592 76.3317C122.584 75.4509 126.593 76.489 127.411 80.3267C128.534 85.6114 123.658 88.8605 117.192 87.0045C111.561 85.3867 108.973 85.2025 105.971 85.4227C102.807 85.6968 100.407 88.6403 101.054 91.9926C101.432 93.9564 102.928 95.5742 104.843 96.1539C106.582 96.6797 108.343 96.1899 109.898 95.354C112.509 93.952 114.702 92.3387 117.839 93.0172C120.005 93.4846 121.47 94.7608 123.047 96.2079C124.413 97.4661 125.95 99.0794 127.923 99.2187C129.545 99.3311 131.118 98.4098 132.74 98.8277C134.066 99.1693 135.023 100.351 135.023 101.726C135.023 105.856 130.543 108.256 126.521 106.858C124.962 106.314 123.69 105.362 122.836 103.942C122.153 102.8 121.731 101.511 120.886 100.468C119.699 99.003 117.722 98.1627 115.844 98.4143C112.532 98.8592 110.896 102.886 112.891 105.537C114.069 107.105 115.92 107.438 117.542 108.337C118.98 109.137 120.005 110.35 119.376 112.058C118.841 113.505 117.079 114.183 115.197 113.765C112.455 113.154 110.038 110.139 108.86 108.678C107.867 107.537 106.33 106.867 104.632 107.195C102.87 107.532 100.686 109.779 101.27 115.599C102.021 123.117 103.886 125.229 106.685 125.229C108.55 125.229 109.669 123.688 109.669 122.052C109.687 121.993 109.701 121.953 109.701 121.953C109.773 119.684 110.051 118.726 110.743 118.115C111.453 117.482 112.622 117.482 113.453 117.855C114.563 118.358 114.698 119.477 114.545 120.573C114.356 121.913 114.123 123.319 115.372 124.218C116.073 124.721 116.671 124.762 116.671 124.762C119.816 125.251 119.439 120.865 121.331 120.488C123.587 120.039 125.272 122.034 124.768 125.22C124.265 128.406 121.061 132.846 112.604 130.689C109.79 129.97 107.966 129.714 105.76 130.069C102.794 130.55 100.066 133.529 100.511 137.236C100.938 140.805 103.279 142 107.786 142C129.792 142 142.029 121.216 142.029 96.846C142.029 72.476 129.411 55.8623 107.768 51.701H107.759Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.6239 130.069C87.4174 129.714 85.593 129.97 82.7798 130.689C74.318 132.846 71.1184 128.406 70.6151 125.22C70.1117 122.034 71.7969 120.039 74.0528 120.488C75.9447 120.865 75.5672 125.251 78.7129 124.762C78.7129 124.762 79.3106 124.721 80.0116 124.218C81.2609 123.319 81.0272 121.912 80.8385 120.573C80.6857 119.472 80.8205 118.353 81.9305 117.855C82.7619 117.477 83.9302 117.482 84.6403 118.115C85.3323 118.731 85.6109 119.684 85.6828 121.953C85.6828 121.953 85.6963 121.993 85.7143 122.052C85.7143 123.688 86.8333 125.229 88.6982 125.229C91.5023 125.229 93.3628 123.117 94.1133 115.599C94.693 109.779 92.5135 107.532 90.7519 107.195C89.0532 106.872 87.5163 107.541 86.5232 108.678C85.3503 110.139 82.9281 113.154 80.1869 113.765C78.304 114.183 76.5424 113.505 76.0076 112.057C75.3785 110.35 76.4031 109.132 77.8411 108.337C79.4634 107.438 81.3103 107.105 82.4922 105.537C84.4875 102.886 82.8517 98.8546 79.5398 98.4143C77.6614 98.1626 75.6841 99.0074 74.4977 100.468C73.6529 101.511 73.2305 102.805 72.5474 103.942C71.6936 105.362 70.4218 106.314 68.8625 106.858C64.836 108.256 60.3602 105.856 60.3602 101.726C60.3602 100.351 61.3128 99.1692 62.643 98.8277C64.2653 98.4098 65.8336 99.331 67.4604 99.2187C69.4332 99.0793 70.9701 97.4706 72.3362 96.2078C73.909 94.7608 75.3785 93.4845 77.5445 93.0172C80.6812 92.3386 82.8787 93.9519 85.4851 95.354C87.04 96.1898 88.8016 96.6796 90.5407 96.1539C92.455 95.5742 93.947 93.9564 94.3289 91.9926C94.9761 88.6402 92.5764 85.6967 89.4127 85.4226C86.4108 85.2024 83.8224 85.3867 78.1916 87.0044C71.725 88.8604 66.8492 85.6159 67.9727 80.3266C68.7861 76.4889 72.799 75.4553 75.7919 76.3316C77.8411 77.0866 80.47 76.3316 81.5081 74.2285C82.6046 72.013 81.6878 69.3302 79.005 68.2562C76.5694 67.281 74.9606 65.2319 76.4301 63.2501C78.8253 60.0235 86.1727 62.931 86.8962 66.6968C87.6197 70.4627 85.2874 73.469 85.2874 77.4775C85.2874 80.1514 87.5837 82.2904 90.3115 82.0298C92.6887 81.8051 94.1762 79.657 94.4368 77.2798C94.9985 72.1389 95.0615 62.5491 94.4368 57.1924C94.0189 53.6333 91.1428 51.0224 87.6242 51.701C65.9819 55.8578 53.3633 72.2512 53.3633 96.8459C53.3633 121.441 65.5999 142 87.6062 142C92.1135 142 94.4503 140.804 94.8817 137.236C95.3266 133.529 92.6033 130.55 89.6329 130.069H89.6239Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3311_24019",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_24019"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_24019",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint1_linear_3324_24164)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 140C112.242 140 140 112.242 140 78C140 43.7583 112.242 16 78 16C43.7583 16 16 43.7583 16 78C16 112.242 43.7583 140 78 140Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M89.0508 27.6224C85.2013 26.885 82.0548 29.7365 81.5976 33.6302C80.9142 39.4856 80.9831 49.9771 81.5976 55.6063C81.8827 58.2021 83.5101 60.5521 86.1108 60.8028C89.095 61.088 91.6073 58.7478 91.6073 55.8226C91.6073 51.4372 89.0508 48.1432 89.8472 44.0283C90.6388 39.9084 98.677 36.7275 101.297 40.2574C102.905 42.4255 101.145 44.6674 98.4803 45.7342C95.5453 46.9092 94.5423 49.8443 95.7419 52.2681C96.8825 54.5689 99.7537 55.3998 101.996 54.5689C105.27 53.6053 109.655 54.741 110.55 58.9395C111.779 64.7212 106.445 68.2757 99.3702 66.2452C93.21 64.4753 90.3782 64.2738 87.0941 64.5147C83.633 64.8146 81.0076 68.0348 81.7156 71.7024C82.1286 73.8508 83.7657 75.6207 85.8601 76.2549C87.7627 76.8301 89.6899 76.2942 91.391 75.3798C94.2474 73.8459 96.6465 72.0809 100.078 72.8233C102.448 73.3346 104.051 74.7308 105.776 76.3139C107.271 77.6905 108.952 79.4555 111.11 79.6079C112.885 79.7308 114.606 78.7229 116.381 79.1801C117.831 79.5538 118.878 80.8468 118.878 82.3512C118.878 86.8693 113.977 89.4946 109.576 87.9656C107.871 87.3708 106.479 86.3285 105.545 84.7749C104.798 83.5262 104.336 82.1152 103.411 80.9746C102.113 79.3719 99.9503 78.4525 97.8953 78.7278C94.2719 79.2145 92.4824 83.6196 94.6652 86.5202C95.9533 88.236 97.9789 88.5998 99.7537 89.5831C101.327 90.4582 102.448 91.7856 101.76 93.6538C101.174 95.2369 99.2473 95.9793 97.1873 95.5221C94.1884 94.8534 91.5434 91.5546 90.2553 89.9568C89.1688 88.708 87.4874 87.9755 85.629 88.3344C83.7018 88.7031 81.3125 91.1613 81.9516 97.5279C82.7726 105.753 84.8129 108.064 87.8758 108.064C89.916 108.064 91.1402 106.377 91.1402 104.588C91.1599 104.524 91.1746 104.48 91.1746 104.48C91.2533 101.997 91.5581 100.95 92.3152 100.281C93.092 99.5879 94.3703 99.5879 95.2798 99.9959C96.4941 100.547 96.6416 101.771 96.4745 102.97C96.268 104.435 96.0123 105.974 97.379 106.957C98.146 107.508 98.7999 107.552 98.7999 107.552C102.241 108.088 101.828 103.29 103.898 102.877C106.366 102.385 108.21 104.568 107.659 108.054C107.109 111.54 103.603 116.397 94.3506 114.037C91.273 113.25 89.2769 112.97 86.863 113.359C83.6182 113.885 80.634 117.144 81.1207 121.2C81.5878 125.104 84.1492 126.411 89.0803 126.411C113.156 126.411 126.543 103.673 126.543 77.012C126.543 50.3507 112.738 32.175 89.0606 27.6224H89.0508Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.209 113.358C66.7951 112.97 64.7991 113.25 61.7214 114.037C52.464 116.397 48.9635 111.539 48.4129 108.054C47.8623 104.568 49.7059 102.385 52.1739 102.877C54.2437 103.29 53.8307 108.088 57.2721 107.552C57.2721 107.552 57.926 107.508 58.693 106.957C60.0597 105.974 59.8041 104.435 59.5976 102.97C59.4304 101.766 59.5779 100.541 60.7922 99.9957C61.7018 99.5827 62.98 99.5877 63.7568 100.281C64.5139 100.954 64.8187 101.997 64.8974 104.479C64.8974 104.479 64.9121 104.524 64.9318 104.588C64.9318 106.377 66.156 108.063 68.1963 108.063C71.2641 108.063 73.2994 105.753 74.1205 97.5277C74.7547 91.161 72.3702 88.7029 70.443 88.3342C68.5847 87.9802 66.9033 88.7127 65.8167 89.9565C64.5336 91.5544 61.8837 94.8532 58.8847 95.5219C56.8248 95.9791 54.8976 95.2367 54.3125 93.6536C53.6242 91.7854 54.7452 90.4531 56.3184 89.5829C58.0932 88.5996 60.1138 88.2358 61.4068 86.52C63.5896 83.6194 61.8001 79.2094 58.1768 78.7276C56.1217 78.4523 53.9585 79.3766 52.6606 80.9744C51.7364 82.115 51.2742 83.5309 50.5269 84.7747C49.5928 86.3283 48.2015 87.3706 46.4955 87.9654C42.0905 89.4944 37.1938 86.8691 37.1938 82.351C37.1938 80.8466 38.2361 79.5536 39.6913 79.1799C41.4661 78.7227 43.1819 79.7306 44.9616 79.6076C47.1199 79.4552 48.8013 77.6952 50.2959 76.3137C52.0166 74.7306 53.6242 73.3344 55.9939 72.8231C59.4255 72.0807 61.8296 73.8457 64.6811 75.3796C66.3821 76.294 68.3093 76.8299 70.212 76.2547C72.3063 75.6205 73.9385 73.8506 74.3564 71.7022C75.0644 68.0346 72.4391 64.8144 68.978 64.5145C65.6939 64.2736 62.862 64.4751 56.7019 66.245C49.6272 68.2755 44.293 64.7259 45.5221 58.9393C46.4119 54.7408 50.8022 53.61 54.0765 54.5687C56.3184 55.3946 59.1944 54.5687 60.3301 52.2679C61.5297 49.8441 60.5268 46.909 57.5917 45.734C54.9271 44.6672 53.167 42.4253 54.7746 40.2572C57.3951 36.7273 65.4333 39.9082 66.2248 44.0281C67.0163 48.148 64.4648 51.437 64.4648 55.8224C64.4648 58.7476 66.977 61.0878 69.9612 60.8026C72.562 60.5568 74.1893 58.2068 74.4744 55.6061C75.089 49.9818 75.1578 39.4903 74.4744 33.63C74.0172 29.7363 70.8708 26.8799 67.0213 27.6222C43.3442 32.1698 29.5391 50.1047 29.5391 77.0118C29.5391 103.919 42.9263 126.411 67.0016 126.411C71.9327 126.411 74.4892 125.103 74.9612 121.2C75.4479 117.144 72.4686 113.884 69.2189 113.358H69.209Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "0",
      "y": "0",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', {
    ref: "generating",
    staticClass: "RechargeDifference--circle group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-21",
      "y": "596"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3311_23940)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "53.9999"
    }
  }, [_vm._v("GENERATING POWER")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "82.9999"
    }
  }, [_vm._v("\n                      Providing a platform to amplify\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "107"
    }
  }, [_vm._v("\n                      community stories, collectively address\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "131"
    }
  }, [_vm._v("\n                      critical issues and empower the next\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "155"
    }
  }, [_vm._v("generation of leaders.")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99",
      "cy": "97.9999",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.2444 159.489C132.069 159.489 159.489 132.069 159.489 98.2444C159.489 64.4201 132.069 37 98.2444 37C64.4201 37 37 64.4201 37 98.2444C37 132.069 64.4201 159.489 98.2444 159.489Z",
      "stroke": "white",
      "stroke-width": "6.10619",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M151.692 93.5157C151.425 90.6623 150.695 86.7031 149.372 82.6254C147.683 77.4221 145.348 72.8606 143.048 69.548C141.626 67.5042 140.007 66.6749 138.076 67.3019C136.146 67.9288 135.09 70.0022 135.717 71.9325L140.377 86.2785C141.024 88.268 139.938 90.4698 137.914 91.0128C136.013 91.5262 134.093 90.45 133.505 88.6284L130.198 78.444C129.571 76.5137 127.497 75.4573 125.567 76.0842C123.637 76.7112 122.58 78.7846 123.207 80.7149L125.641 88.2088C126.298 90.2229 125.192 92.4494 123.148 92.9974C121.223 93.5157 119.282 92.4297 118.685 90.5883L117.797 87.8484C117.17 85.9181 115.096 84.8617 113.166 85.4886C111.236 86.1156 110.179 88.189 110.806 90.1193L110.87 90.3118C111.581 92.4938 110.14 94.7795 107.869 95.0856L107.731 95.1053C105.85 95.3571 104.3 93.6589 104.719 91.8076L104.872 91.1313H104.862L113.66 54.4121C114.4 51.3119 114.203 48.0932 110.041 47.1552C107.242 46.5282 103.253 46 98.968 46C93.4981 46 88.438 46.8047 84.5775 47.9747C82.193 48.6954 80.9046 49.979 80.9046 52.008C80.9046 54.0369 82.5485 55.6809 84.5775 55.6809H99.6591C101.752 55.6809 103.51 57.3939 103.401 59.4871C103.302 61.4568 101.688 62.9428 99.7726 62.9428H89.0649C87.0359 62.9428 85.392 64.5867 85.392 66.6157C85.392 68.6446 87.0359 70.2885 89.0649 70.2885H96.9439C99.0618 70.2885 100.839 72.0213 100.73 74.1392C100.627 76.1287 98.9926 77.6393 97.0624 77.6393H94.1843C92.1553 77.6393 90.5114 79.2832 90.5114 81.3122C90.5114 83.3412 92.1553 84.9851 94.1843 84.9851H94.3867C96.6773 84.9851 98.4101 87.0635 98.0004 89.3146L97.9757 89.4528C97.635 91.3189 95.5369 92.2717 93.9128 91.2991L93.3203 90.9437V90.9536L61.1133 71.2364C58.3932 69.5727 55.2683 68.7631 53.0912 72.436C51.6299 74.9044 49.8923 78.5328 48.5692 82.6106C46.8809 87.8138 46.0811 92.8739 46.0021 96.9072C45.9527 99.3953 46.7722 101.02 48.7025 101.646C50.6327 102.273 52.7061 101.217 53.3331 99.2867L57.9934 84.9407C58.6401 82.9512 60.8122 81.8108 62.7672 82.5562C64.6086 83.2622 65.5267 85.2566 64.9343 87.0733L61.6268 97.2577C60.9998 99.188 62.0563 101.261 63.9865 101.888C65.9168 102.515 67.9902 101.459 68.6171 99.5286L71.0509 92.0347C71.7075 90.0205 73.9043 88.8703 75.879 89.6256C77.7401 90.3365 78.6683 92.3556 78.0709 94.197L77.1823 96.9369C76.5553 98.8671 77.6118 100.941 79.5421 101.567C81.4723 102.194 83.5457 101.138 84.1727 99.2077L84.2369 99.0152C84.9428 96.8332 87.4556 95.831 89.4747 96.9171L89.5981 96.9813C91.2667 97.8798 91.5234 100.17 90.0967 101.419L89.5783 101.874H89.5882L60.8863 126.414C58.4623 128.487 56.7296 131.207 59.5484 134.411C61.4441 136.564 64.3617 139.338 67.8273 141.856C72.2506 145.07 76.8219 147.39 80.633 148.718C82.9829 149.537 84.7848 149.256 85.9745 147.612C87.1692 145.973 86.8039 143.673 85.16 142.483L72.9565 133.617C71.2632 132.387 70.8485 129.968 72.1666 128.339C73.4057 126.809 75.5878 126.552 77.1329 127.673L85.7919 133.967C87.4309 135.162 89.7314 134.796 90.9211 133.152C92.1158 131.509 91.7505 129.213 90.1065 128.023L83.7284 123.393C82.0153 122.149 81.6007 119.7 82.9286 118.056C84.1825 116.506 86.3892 116.244 87.9541 117.385L90.2843 119.078C91.9233 120.273 94.2237 119.907 95.4135 118.263C96.6082 116.624 96.2429 114.324 94.599 113.134L94.436 113.016C92.5798 111.668 92.4021 108.968 94.0559 107.388L94.1596 107.289C95.532 105.981 97.7881 106.44 98.5335 108.188L98.8051 108.824V108.815L113.279 143.697C114.499 146.644 116.552 149.133 120.472 147.439C123.103 146.304 126.643 144.383 130.114 141.866C134.537 138.652 138.155 135.023 140.594 131.81C142.1 129.825 142.386 128.028 141.196 126.389C140.002 124.75 137.706 124.385 136.067 125.575L123.864 134.441C122.17 135.67 119.742 135.315 118.601 133.562C117.525 131.913 117.954 129.756 119.505 128.63L128.169 122.336C129.808 121.141 130.173 118.846 128.983 117.207C127.788 115.563 125.493 115.203 123.854 116.392L117.476 121.023C115.763 122.267 113.304 121.907 112.149 120.134C111.063 118.466 111.497 116.284 113.062 115.148L115.392 113.455C117.031 112.26 117.397 109.965 116.207 108.326C115.012 106.687 112.717 106.322 111.078 107.511L110.915 107.63C109.059 108.977 106.437 108.316 105.445 106.247L105.386 106.119C104.566 104.411 105.702 102.407 107.587 102.239L108.279 102.175H108.274L145.921 99.188C149.1 98.9362 152.102 97.7514 151.707 93.5009L151.692 93.5157Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3311_23940",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_23940"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_23940",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint0_linear_3324_24164)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 756C112.242 756 140 728.242 140 694C140 659.758 112.242 632 78 632C43.7583 632 16 659.758 16 694C16 728.242 43.7583 756 78 756Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M130.51 689.439C130.244 686.585 129.513 682.626 128.19 678.548C126.502 673.345 124.167 668.783 121.866 665.471C120.444 663.427 118.825 662.598 116.895 663.225C114.965 663.852 113.908 665.925 114.535 667.855L119.195 682.201C119.842 684.191 118.756 686.393 116.732 686.936C114.831 687.449 112.911 686.373 112.323 684.551L109.016 674.367C108.389 672.437 106.315 671.38 104.385 672.007C102.455 672.634 101.399 674.707 102.025 676.638L104.459 684.132C105.116 686.146 104.01 688.372 101.966 688.92C100.041 689.439 98.1008 688.353 97.5035 686.511L96.6149 683.771C95.9879 681.841 93.9145 680.785 91.9843 681.411C90.054 682.038 88.9975 684.112 89.6245 686.042L89.6887 686.235C90.3996 688.417 88.9581 690.702 86.6872 691.008L86.5489 691.028C84.6681 691.28 83.118 689.582 83.5376 687.73L83.6906 687.054H83.6807L92.4779 650.335C93.2184 647.235 93.0209 644.016 88.8593 643.078C86.0602 642.451 82.0714 641.923 77.7863 641.923C72.3164 641.923 67.2563 642.728 63.3958 643.898C61.0114 644.618 59.7229 645.902 59.7229 647.931C59.7229 649.96 61.3668 651.604 63.3958 651.604H78.4775C80.5706 651.604 82.3281 653.317 82.2195 655.41C82.1207 657.38 80.5064 658.866 78.591 658.866H67.8833C65.8543 658.866 64.2104 660.51 64.2104 662.539C64.2104 664.567 65.8543 666.211 67.8833 666.211H75.7623C77.8801 666.211 79.6573 667.944 79.5487 670.062C79.445 672.052 77.811 673.562 75.8808 673.562H73.0026C70.9736 673.562 69.3297 675.206 69.3297 677.235C69.3297 679.264 70.9736 680.908 73.0026 680.908H73.205C75.4957 680.908 77.2285 682.986 76.8187 685.237L76.794 685.376C76.4534 687.242 74.3553 688.195 72.7311 687.222L72.1387 686.867V686.876L39.9317 667.159C37.2116 665.496 34.0866 664.686 31.9095 668.359C30.4483 670.827 28.7106 674.456 27.3876 678.533C25.6992 683.737 24.8994 688.797 24.8205 692.83C24.7711 695.318 25.5906 696.942 27.5208 697.569C29.4511 698.196 31.5245 697.14 32.1514 695.21L36.8117 680.864C37.4584 678.874 39.6306 677.734 41.5855 678.479C43.4269 679.185 44.3451 681.179 43.7527 682.996L40.4451 693.181C39.8182 695.111 40.8746 697.184 42.8049 697.811C44.7351 698.438 46.8085 697.382 47.4355 695.451L49.8693 687.958C50.5258 685.943 52.7227 684.793 54.6974 685.548C56.5585 686.259 57.4866 688.278 56.8893 690.12L56.0007 692.86C55.3737 694.79 56.4302 696.863 58.3604 697.49C60.2907 698.117 62.3641 697.061 62.991 695.131L63.0552 694.938C63.7612 692.756 66.2739 691.754 68.293 692.84L68.4165 692.904C70.0851 693.803 70.3418 696.093 68.9151 697.342L68.3967 697.796H68.4066L39.7046 722.337C37.2807 724.41 35.5479 727.13 38.3668 730.334C40.2625 732.487 43.1801 735.261 46.6456 737.779C51.0689 740.993 55.6403 743.313 59.4514 744.641C61.8013 745.46 63.6031 745.179 64.7929 743.535C65.9876 741.896 65.6223 739.595 63.9784 738.406L51.7748 729.539C50.0815 728.31 49.6669 725.891 50.985 724.262C52.2241 722.732 54.4061 722.475 55.9513 723.596L64.6102 729.89C66.2492 731.085 68.5497 730.719 69.7395 729.075C70.9341 727.431 70.5688 725.136 68.9249 723.946L62.5467 719.315C60.8337 718.071 60.419 715.623 61.747 713.979C63.0009 712.429 65.2076 712.167 66.7725 713.308L69.1027 715.001C70.7417 716.195 73.0421 715.83 74.2319 714.186C75.4265 712.547 75.0613 710.247 73.4173 709.057L73.2544 708.939C71.3982 707.591 71.2205 704.89 72.8743 703.311L72.978 703.212C74.3504 701.904 76.6064 702.363 77.3519 704.11L77.6234 704.747V704.737L92.0978 739.62C93.3172 742.567 95.3708 745.055 99.2905 743.362C101.922 742.227 105.461 740.306 108.932 737.789C113.355 734.575 116.974 730.946 119.413 727.733C120.918 725.748 121.205 723.951 120.015 722.312C118.82 720.673 116.525 720.308 114.886 721.497L102.682 730.364C100.989 731.593 98.5599 731.238 97.4196 729.485C96.3434 727.836 96.7728 725.679 98.323 724.553L106.987 718.259C108.626 717.064 108.991 714.769 107.801 713.13C106.607 711.486 104.311 711.125 102.672 712.315L96.294 716.946C94.581 718.19 92.1225 717.83 90.9673 716.057C89.8812 714.389 90.3156 712.207 91.8806 711.071L94.2107 709.378C95.8497 708.183 96.215 705.888 95.0253 704.249C93.8306 702.61 91.535 702.244 89.896 703.434L89.7331 703.553C87.8769 704.9 85.2555 704.239 84.2633 702.17L84.204 702.042C83.3845 700.334 84.5199 698.33 86.4058 698.162L87.0969 698.098H87.092L124.739 695.111C127.918 694.859 130.92 693.674 130.525 689.424L130.51 689.439Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "0",
      "y": "616",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$afterImages = _vm.blok.afterImages) !== null && _vm$blok$afterImages !== void 0 && _vm$blok$afterImages[0] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages2 = _vm.blok.afterImages) === null || _vm$blok$afterImages2 === void 0 ? void 0 : _vm$blok$afterImages2[0]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$afterImages3 = _vm.blok.afterImages) !== null && _vm$blok$afterImages3 !== void 0 && _vm$blok$afterImages3[1] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages4 = _vm.blok.afterImages) === null || _vm$blok$afterImages4 === void 0 ? void 0 : _vm$blok$afterImages4[1]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3324_24164",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3324_24164",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "RechargeDifference--after flex justify-end relative",
    style: {
      willChange: 'transform'
    },
    on: {
      "mouseenter": _vm.changeZIndex
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto overflow-visible w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1816",
      "viewBox": "0 0 156 1816",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    ref: "revitalizing",
    staticClass: "group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-20",
      "y": "-20"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3491_23920)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "63.9999"
    }
  }, [_vm._v("\n                      REVITALIZING THE COMMUNITY\n                    ")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "92.9999"
    }
  }, [_vm._v("\n                      Generating a positive impact in host\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "117"
    }
  }, [_vm._v("\n                      locations, replenishing the communities\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "141"
    }
  }, [_vm._v("and places we touch down.")])]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_3491_23920)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M98 175C140.526 175 175 140.526 175 98C175 55.4741 140.526 21 98 21C55.4741 21 21 55.4741 21 98C21 140.526 55.4741 175 98 175Z",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.0008 159.2C131.801 159.2 159.201 131.8 159.201 98C159.201 64.2001 131.801 36.8 98.0008 36.8C64.2008 36.8 36.8008 64.2001 36.8008 98C36.8008 131.8 64.2008 159.2 98.0008 159.2Z",
      "stroke": "white",
      "stroke-width": "6.1062",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.4992 49.7C85.2992 48.8 88.1992 48.1 91.2992 47.7L94.2992 103.1C92.6992 103.2 90.9992 103.4 89.3992 103.7L77.1992 51.7999C78.8992 51.0999 80.5992 50.3 82.4992 49.7Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M67.1004 112.6L47.4004 96.4C47.6004 90.8 48.7004 85.4 50.5004 80.4L70.8004 110.3C69.6004 111 68.3004 111.8 67.1004 112.6Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M82.1 105.4C80.6 105.9 79.1 106.4 77.6 107L57 68.3C59.7 64.6 62.9 61.2 66.5 58.3L82.1 105.4Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.699 103.8C105.099 103.5 103.399 103.3 101.699 103.2L104.799 47.8C107.999 48.2 111.199 49 114.199 50C115.799 50.6 117.399 51.2 118.899 51.9L106.699 103.8Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.001 68.3L118.301 107.1C116.801 106.5 115.301 106 113.801 105.5L129.401 58.4C133.101 61.2 136.301 64.6 139.001 68.3Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M48.9004 110.7L60.7004 117.6C58.5004 119.7 56.4004 121.9 54.6004 124.2C52.1004 120.1 50.2004 115.6 48.9004 110.7Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M147.099 110.7C145.799 115.6 143.899 120.1 141.399 124.3C139.499 121.9 137.499 119.7 135.199 117.7L147.099 110.7Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M125.1 110.4L145.5 80.4C147.4 85.4 148.5 90.8 148.6 96.4L128.7 112.7C127.6 111.8 126.4 111.1 125.1 110.4Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "2.0354"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.1992 150C113.999 150 128.199 142.9 137.699 131.7C129.099 119.1 114.599 112 98.1992 112C81.7992 112 67.2992 119.1 58.6992 131.7C68.2992 142.9 82.3992 150 98.1992 150Z",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3491_23920",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3491_23920"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3491_23920",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip0_3491_23920"
    }
  }, [_c('rect', {
    attrs: {
      "width": "156",
      "height": "156",
      "fill": "white",
      "transform": "translate(20 20)"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint0_linear_3324_24171)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 140C112.242 140 140 112.242 140 78C140 43.7583 112.242 16 78 16C43.7583 16 16 43.7583 16 78C16 112.242 43.7583 140 78 140Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M68.4203 84.9855C70.4933 84.6122 72.5615 84.3666 74.6198 84.2388C74.6198 84.2388 74.9686 84.2388 75.2338 84.2388L72.1144 25.9526C68.6119 26.3407 65.2124 27.0776 61.9555 28.119C59.7891 28.8854 57.6915 29.7647 55.7363 30.6833L68.4154 84.9806L68.4203 84.9855Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.9838 90.7822L29.6813 57.9229C27.2447 63.7638 25.8496 70.1401 25.6973 76.826C25.6973 76.826 25.6973 76.8358 25.7022 76.8358L46.6783 94.0244C48.3584 92.8553 50.1318 91.7794 51.9789 90.7822H51.9838Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M63.2478 86.1842L46.6585 36.1411C46.6585 36.1411 46.6585 36.1411 46.6536 36.1411C42.2766 39.4177 38.4449 43.3771 35.2812 47.8377C35.2812 47.8377 35.2812 47.8426 35.2812 47.8475L56.9058 88.4145C59.0133 87.5302 61.1306 86.7884 63.2527 86.1842H63.2478Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.9996 92.3003C61.4004 92.2807 47.1838 100.219 38.248 112.058C46.9431 122.212 59.4551 129.001 73.5686 130.19C74.0401 130.229 74.5068 130.264 74.9833 130.288C75.003 130.288 75.0275 130.288 75.0472 130.288C75.5188 130.313 75.9904 130.332 76.4669 130.347C76.4816 130.347 76.5013 130.347 76.516 130.347C77.0023 130.362 77.4887 130.367 77.9799 130.367C78.0978 130.367 78.2157 130.367 78.3336 130.367C78.6775 130.367 79.0214 130.362 79.3652 130.352C79.6452 130.347 79.9253 130.332 80.2003 130.323C80.3772 130.313 80.559 130.308 80.7358 130.298C81.0502 130.283 81.3695 130.259 81.6839 130.239C81.8215 130.229 81.959 130.22 82.0916 130.21C82.4306 130.185 82.7647 130.151 83.0987 130.121C83.2068 130.111 83.3198 130.102 83.4278 130.087C83.7815 130.052 84.1352 130.008 84.4889 129.964C84.5724 129.954 84.6559 129.944 84.7395 129.93C85.1128 129.881 85.4861 129.831 85.8595 129.772C85.9135 129.763 85.9676 129.758 86.0167 129.748C86.4195 129.684 86.8174 129.62 87.2153 129.551C87.2251 129.551 87.2301 129.551 87.2399 129.551C91.1011 128.859 94.8149 127.749 98.3322 126.26L98.3518 126.25C98.735 126.088 99.1182 125.921 99.4964 125.749C99.5063 125.744 99.521 125.739 99.5308 125.734C99.9091 125.563 100.287 125.386 100.661 125.209C100.661 125.209 100.661 125.209 100.666 125.209C102.542 124.305 104.355 123.293 106.099 122.178C106.133 122.158 106.163 122.139 106.197 122.119C106.452 121.952 106.708 121.785 106.963 121.613C107.081 121.534 107.199 121.456 107.317 121.377C107.533 121.23 107.744 121.082 107.961 120.93C108.118 120.822 108.275 120.714 108.427 120.601C108.614 120.468 108.801 120.331 108.987 120.193C109.169 120.061 109.346 119.928 109.523 119.795C109.685 119.672 109.852 119.545 110.014 119.422C110.215 119.27 110.412 119.112 110.608 118.955C110.751 118.842 110.888 118.729 111.031 118.616C111.252 118.435 111.473 118.253 111.694 118.066C111.807 117.973 111.92 117.875 112.033 117.781C112.288 117.56 112.544 117.334 112.799 117.108C112.873 117.044 112.947 116.98 113.016 116.917C114.71 115.384 116.307 113.748 117.795 112.009C108.575 99.949 93.9208 92.148 77.9996 92.3052V92.3003Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M87.5709 85.0203L100.26 30.6887C98.5011 29.8585 96.6245 29.0676 94.6841 28.3553C91.2307 27.191 87.6151 26.3854 83.8816 25.9629L80.6689 84.254C80.5559 84.254 81.3763 84.254 81.3763 84.254C83.4641 84.3915 85.5322 84.647 87.5709 85.0203Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.7324 86.2387C94.889 86.8577 97.0013 87.6093 99.0547 88.4886L120.714 47.848C120.714 47.848 120.714 47.8431 120.714 47.8381C117.55 43.3727 113.718 39.4182 109.341 36.1416C109.341 36.1416 109.341 36.1416 109.336 36.1416L92.7324 86.2387Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.9863 97.6944L26.7773 88.7832C28.1086 95.1596 30.6041 101.099 34.0232 106.389C36.3321 103.245 38.9897 100.323 41.9912 97.6944H41.9863Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.881 97.7676C116.848 100.352 119.55 103.255 121.932 106.423C121.937 106.433 121.952 106.433 121.957 106.423C125.386 101.123 127.891 95.164 129.222 88.7729L113.881 97.7627V97.7676Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M126.315 57.9229L103.963 90.8657C105.771 91.8531 107.52 92.9388 109.204 94.1227L130.294 76.8407L130.299 76.8309C130.146 70.145 128.751 63.7687 126.315 57.9278V57.9229Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "0",
      "y": "0",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', {
    ref: "advancing",
    staticClass: "group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-21",
      "y": "596"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3311_23962)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "62.9999"
    }
  }, [_vm._v("ADVANCING THE MOVEMENT")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "91.9999"
    }
  }, [_vm._v("\n                      Rallying leaders around a shared vision,\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "116"
    }
  }, [_vm._v("\n                      unlocking actionable strategies that\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "140"
    }
  }, [_vm._v("\n                      advance the global movement.\n                    ")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "99",
      "cy": "97.9999",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.2444 159.489C132.069 159.489 159.489 132.069 159.489 98.2444C159.489 64.4201 132.069 37 98.2444 37C64.4201 37 37 64.4201 37 98.2444C37 132.069 64.4201 159.489 98.2444 159.489Z",
      "stroke": "white",
      "stroke-width": "6.10619",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_3311_23962)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M149.73 85.405C145.32 66.6196 130.547 51.846 111.762 47.4311C77.529 39.3978 47.0723 65.1546 47.0723 98.0203C47.0723 106.83 49.1814 112.72 49.1814 112.72C49.1814 91.4963 66.1083 63.5862 99.1462 63.5862C117.101 63.5862 136.21 78.06 136.21 98.0203C136.21 120.257 120.803 138.138 99.1462 138.138C88.1532 138.138 76.3737 132.858 76.3737 120.237C76.3737 106.791 84.5643 101.054 93.6251 97.0419C81.0098 97.5238 67.3178 108.654 67.3178 123.453C67.3178 138.251 81.3539 150.094 99.1511 150.094C132.022 150.094 157.778 119.637 149.74 85.405H149.73Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M85.2578 94.3873L99.1072 94.7904L89.4416 104.717L96.8014 110.454L104.073 98.6596L107.839 111.993L116.486 108.492L109.903 96.2948L123.335 99.7019L124.623 90.4641L110.774 90.0609L120.439 80.1348L113.084 74.3975L105.813 86.1918L102.047 72.8586L93.3993 76.3591L99.9773 88.5565L86.5459 85.1495L85.2578 94.3873Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3311_23962",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_23962"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_23962",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip0_3311_23962"
    }
  }, [_c('rect', {
    attrs: {
      "width": "104.143",
      "height": "104.143",
      "fill": "white",
      "transform": "translate(47.0723 45.9515)"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint2_linear_3324_24171)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 756C112.242 756 140 728.242 140 694C140 659.758 112.242 632 78 632C43.7584 632 16 659.758 16 694C16 728.242 43.7584 756 78 756Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clip0_3324_24171)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M128.73 681.405C124.32 662.62 109.547 647.846 90.7615 643.431C56.529 635.398 26.0723 661.155 26.0723 694.021C26.0723 702.831 28.1814 708.72 28.1814 708.72C28.1814 687.497 45.1083 659.586 78.1462 659.586C96.1007 659.586 115.21 674.06 115.21 694.021C115.21 716.257 99.8027 734.138 78.1462 734.138C67.1532 734.138 55.3737 728.858 55.3737 716.237C55.3737 702.791 63.5643 697.054 72.6251 693.042C60.0098 693.524 46.3178 704.655 46.3178 719.453C46.3178 734.251 60.3539 746.094 78.1511 746.094C111.022 746.094 136.778 715.638 128.74 681.405H128.73Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64.2578 690.388L78.1072 690.791L68.4416 700.717L75.8014 706.454L83.0727 694.66L86.8386 707.993L95.4864 704.493L88.9034 692.295L102.335 695.702L103.623 686.464L89.7736 686.061L99.4392 676.135L92.0843 670.398L84.813 682.192L81.0471 668.859L72.3993 672.359L78.9773 684.557L65.5459 681.15L64.2578 690.388Z",
      "fill": "#FAFAF4"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "0",
      "y": "616",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', {
    ref: "freshAir",
    staticClass: "group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-21",
      "y": "1212"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3311_23990)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "65"
    }
  }, [_vm._v("FRESH AIR ACTIVITIES")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "200",
      "y": "94"
    }
  }, [_vm._v("\n                      Providing wellness breaks that support\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "118"
    }
  }, [_vm._v("\n                      your holistic health, centering body and\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "200",
      "y": "142"
    }
  }, [_vm._v("mind.")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "98",
      "cy": "98",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.0003 159.244C131.825 159.244 159.245 131.824 159.245 97.9998C159.245 64.1754 131.825 36.7554 98.0003 36.7554C64.1759 36.7554 36.7559 64.1754 36.7559 97.9998C36.7559 131.824 64.1759 159.244 98.0003 159.244Z",
      "stroke": "white",
      "stroke-width": "6.10619",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.764 111.097C118.082 108.464 114.28 106.416 109.721 104.863C93.5444 99.3465 67.3611 100.545 47.5 102.962C45.6333 103.188 45.7709 105.939 47.6474 105.978C62.2276 106.268 76.0119 107.82 87.6396 110.645C93.8588 112.158 98.1768 114.958 100.869 118.21C100.903 118.245 100.928 118.269 100.938 118.299C101.753 119.222 102.436 120.264 102.962 121.408C103.448 122.489 103.797 123.658 103.964 124.891C104.917 131.793 100.093 138.15 93.2005 139.103C90.091 139.53 87.0894 138.798 84.648 137.221C90.0713 147.621 103.276 152.917 115.552 146.575C121.211 143.652 125.308 138.292 126.6 132.054C128.099 124.837 126.36 118.304 122.695 113.367C122.1 112.571 121.457 111.809 120.759 111.092L120.764 111.097Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.5448 98.1771C90.1062 92.3559 113.47 86.402 119.158 69.1151C119.856 67.0175 120.215 63.9619 119.836 61.2159C118.431 51.0324 108.469 44.1107 98.2019 46.7045C98.1921 46.7045 98.1872 46.7094 98.1774 46.7143C97.5093 46.8863 96.8412 47.0926 96.1731 47.3431C95.5934 47.5642 95.0383 47.8196 94.493 48.0947C94.2474 48.2126 94.0067 48.3403 93.766 48.473C93.7611 48.473 93.7513 48.4828 93.7463 48.4828C92.0073 49.4358 90.4451 50.6983 89.0402 52.4422C88.716 52.8352 88.4016 53.243 88.1118 53.6654C87.8269 54.083 87.5714 54.5104 87.3208 54.9525C87.2815 55.0164 87.2471 55.0753 87.2078 55.1392C83.1846 62.1689 85.6702 69.4835 85.6702 69.4835C85.6702 69.4835 85.179 64.6742 87.8808 61.5696C88.937 60.4692 90.2978 59.6537 91.8551 59.2558C92.5084 59.1035 93.2256 59.0102 94.0214 58.9905C97.745 59.0102 101.076 61.599 102.029 65.19C102.456 66.8111 102.387 68.4175 101.93 69.8618C101.675 70.6723 101.316 71.4239 100.85 72.1068C100.815 72.1412 100.801 72.1706 100.776 72.205C99.3465 74.5286 97.0573 76.6901 93.9232 78.773C89.1188 81.966 82.3249 84.9381 73.6397 87.8512C76.6264 84.7661 77.6974 79.8979 75.2706 75.3097C73.9639 72.8436 71.6747 71.0162 68.9582 70.353C61.673 68.5747 55.6749 73.9342 55.5864 80.3597C55.6159 78.2964 58.0328 76.4395 59.821 75.9974C62.4049 75.3539 65.092 76.4543 66.325 78.8516C66.9931 80.1484 67.1455 81.7008 66.7426 83.1057C65.77 86.5101 61.8891 89.1087 59.0055 90.8084C55.4145 92.9306 51.4404 94.2717 47.4023 95.2689C47.2648 95.3033 47.137 95.3377 46.9995 95.3721C45.2457 95.8093 45.7419 98.4277 47.5448 98.1869V98.1771Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121.531 84.2205C119.32 85.6206 115.479 87.7575 112.074 89.0593C105.683 91.5204 97.8576 93.3282 92.3999 94.4187C91.5206 94.5956 91.6483 95.8925 92.5472 95.8925C98.7615 95.8826 115.857 94.0405 125.539 90.1597C125.549 90.1498 125.559 90.1498 125.569 90.1449C132.078 87.5413 136.302 82.6633 136.209 75.9185C136.121 69.6895 129.744 62.9545 124.252 62.8857C126.62 64.2023 134.077 76.2918 121.536 84.2303L121.531 84.2205Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M139.047 81.2729C144.352 83.6211 145.394 91.8101 135.431 94.4432C126.663 96.757 118.169 97.8033 112.186 98.27C111.179 98.3486 111.105 99.8813 112.112 99.9697C120.444 100.697 129.33 101.267 132.97 102.863C139.44 105.693 137.077 113.901 132.238 115.036C132.238 115.036 143.522 115.798 145.33 107.771C146.592 102.185 141.189 99.0265 141.189 99.0265C153.219 95.3569 150.498 80.2413 139.047 81.2828V81.2729Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.0817 118.971C79.4999 117.665 77.5398 116.967 75.624 116.304C69.6455 114.221 60.1891 112.452 51.5235 111.681C50.7326 111.612 50.5558 112.767 51.332 112.934C61.0488 115.031 74.8576 119.59 75.0394 125.127C75.2457 131.341 64.3106 128.88 64.3106 128.88C65.4847 130.486 68.2307 132.628 70.0238 133.492C74.6857 135.742 81.2046 134.892 83.6313 129.808C85.3359 126.237 84.098 121.477 81.0768 118.976L81.0817 118.971Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3311_23990",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_23990"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_23990",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 1388)",
      "fill": "url(#paint1_linear_3324_24171)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M100.764 1323.1C98.0821 1320.46 94.2799 1318.42 89.7211 1316.86C73.5444 1311.35 47.3611 1312.54 27.5 1314.96C25.6333 1315.19 25.7709 1317.94 27.6474 1317.98C42.2276 1318.27 56.0119 1319.82 67.6396 1322.64C73.8588 1324.16 78.1768 1326.96 80.8689 1330.21C80.9033 1330.24 80.9278 1330.27 80.9377 1330.3C81.7531 1331.22 82.4359 1332.26 82.9616 1333.41C83.4479 1334.49 83.7967 1335.66 83.9637 1336.89C84.9167 1343.79 80.0927 1350.15 73.2005 1351.1C70.091 1351.53 67.0894 1350.8 64.648 1349.22C70.0713 1359.62 83.276 1364.92 95.5522 1358.57C101.211 1355.65 105.308 1350.29 106.6 1344.05C108.099 1336.84 106.36 1330.3 102.695 1325.37C102.1 1324.57 101.457 1323.81 100.759 1323.09L100.764 1323.1Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 1372C112.242 1372 140 1344.24 140 1310C140 1275.76 112.242 1248 78 1248C43.7584 1248 16 1275.76 16 1310C16 1344.24 43.7584 1372 78 1372Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.5448 1310.18C70.1062 1304.36 93.4698 1298.4 99.1584 1281.11C99.856 1279.02 100.215 1275.96 99.8363 1273.22C98.4314 1263.03 88.4689 1256.11 78.2019 1258.7C78.1921 1258.7 78.1872 1258.71 78.1774 1258.71C77.5093 1258.89 76.8412 1259.09 76.1731 1259.34C75.5934 1259.56 75.0383 1259.82 74.493 1260.09C74.2474 1260.21 74.0067 1260.34 73.766 1260.47C73.7611 1260.47 73.7513 1260.48 73.7463 1260.48C72.0073 1261.44 70.4451 1262.7 69.0402 1264.44C68.716 1264.83 68.4016 1265.24 68.1118 1265.66C67.8269 1266.08 67.5714 1266.51 67.3208 1266.95C67.2815 1267.02 67.2471 1267.07 67.2078 1267.14C63.1846 1274.17 65.6702 1281.48 65.6702 1281.48C65.6702 1281.48 65.179 1276.67 67.8808 1273.57C68.937 1272.47 70.2978 1271.65 71.8551 1271.26C72.5084 1271.1 73.2256 1271.01 74.0214 1270.99C77.745 1271.01 81.0757 1273.6 82.0287 1277.19C82.4561 1278.81 82.3874 1280.42 81.9305 1281.86C81.675 1282.67 81.3164 1283.42 80.8497 1284.11C80.8153 1284.14 80.8006 1284.17 80.776 1284.2C79.3465 1286.53 77.0573 1288.69 73.9232 1290.77C69.1188 1293.97 62.3249 1296.94 53.6397 1299.85C56.6264 1296.77 57.6974 1291.9 55.2706 1287.31C53.9639 1284.84 51.6747 1283.02 48.9582 1282.35C41.673 1280.57 35.6749 1285.93 35.5864 1292.36C35.6159 1290.3 38.0328 1288.44 39.821 1288C42.4049 1287.35 45.092 1288.45 46.325 1290.85C46.9931 1292.15 47.1455 1293.7 46.7426 1295.11C45.77 1298.51 41.8891 1301.11 39.0055 1302.81C35.4145 1304.93 31.4404 1306.27 27.4023 1307.27C27.2648 1307.3 27.137 1307.34 26.9995 1307.37C25.2457 1307.81 25.7419 1310.43 27.5448 1310.19V1310.18Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M101.531 1296.22C99.3201 1297.62 95.4785 1299.76 92.0742 1301.06C85.6831 1303.52 77.8576 1305.33 72.3999 1306.42C71.5206 1306.6 71.6483 1307.89 72.5472 1307.89C78.7615 1307.88 95.8568 1306.04 105.539 1302.16C105.549 1302.15 105.559 1302.15 105.569 1302.14C112.078 1299.54 116.302 1294.66 116.209 1287.92C116.121 1281.69 109.744 1274.95 104.252 1274.89C106.62 1276.2 114.077 1288.29 101.536 1296.23L101.531 1296.22Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.047 1293.27C124.352 1295.62 125.394 1303.81 115.431 1306.44C106.663 1308.76 98.1691 1309.8 92.1857 1310.27C91.1787 1310.35 91.105 1311.88 92.112 1311.97C100.444 1312.7 109.33 1313.27 112.97 1314.86C119.44 1317.69 117.077 1325.9 112.238 1327.04C112.238 1327.04 123.522 1327.8 125.33 1319.77C126.592 1314.19 121.189 1311.03 121.189 1311.03C133.219 1307.36 130.498 1292.24 119.047 1293.28V1293.27Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M61.0817 1330.97C59.4999 1329.66 57.5398 1328.97 55.624 1328.3C49.6455 1326.22 40.1891 1324.45 31.5235 1323.68C30.7326 1323.61 30.5558 1324.77 31.332 1324.93C41.0488 1327.03 54.8576 1331.59 55.0394 1337.13C55.2457 1343.34 44.3106 1340.88 44.3106 1340.88C45.4847 1342.49 48.2307 1344.63 50.0238 1345.49C54.6857 1347.74 61.2046 1346.89 63.6313 1341.81C65.3359 1338.24 64.098 1333.48 61.0768 1330.98L61.0817 1330.97Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "0",
      "y": "1231",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$afterImages5 = _vm.blok.afterImages) !== null && _vm$blok$afterImages5 !== void 0 && _vm$blok$afterImages5[2] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages6 = _vm.blok.afterImages) === null || _vm$blok$afterImages6 === void 0 ? void 0 : _vm$blok$afterImages6[2]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$afterImages7 = _vm.blok.afterImages) !== null && _vm$blok$afterImages7 !== void 0 && _vm$blok$afterImages7[3] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages8 = _vm.blok.afterImages) === null || _vm$blok$afterImages8 === void 0 ? void 0 : _vm$blok$afterImages8[3]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$afterImages9 = _vm.blok.afterImages) !== null && _vm$blok$afterImages9 !== void 0 && _vm$blok$afterImages9[4] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages0 = _vm.blok.afterImages) === null || _vm$blok$afterImages0 === void 0 ? void 0 : _vm$blok$afterImages0[4]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern2",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3324_24171",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3324_24171",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_3324_24171",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_3324_24171",
      "x1": "77.9983",
      "y1": "185.724",
      "x2": "77.9983",
      "y2": "664.035",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip0_3324_24171"
    }
  }, [_c('rect', {
    attrs: {
      "width": "104.143",
      "height": "104.143",
      "fill": "white",
      "transform": "translate(26.0723 641.952)"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "RechargeDifference--after flex justify-end relative",
    style: {
      willChange: 'transform'
    },
    on: {
      "mouseenter": _vm.changeZIndex
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto overflow-visible w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1200",
      "viewBox": "0 0 156 1200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    ref: "interwoven",
    staticClass: "group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "567",
      "height": "196",
      "viewBox": "0 0 567 196",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "-388",
      "y": "-20"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_b_3311_23977)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 98C0 43.8761 43.8761 0 98 0H469C523.124 0 567 43.8761 567 98C567 152.124 523.124 196 469 196H98C43.8761 196 0 152.124 0 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "62",
      "y": "66"
    }
  }, [_vm._v("INTERWOVEN SUSTAINABILITY")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "62",
      "y": "95"
    }
  }, [_vm._v("\n                      Weaving sustainable practices into the\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "62",
      "y": "119"
    }
  }, [_vm._v("\n                      event experience to simultaneously\n                    ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "62",
      "y": "143"
    }
  }, [_vm._v("support people and planet.")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "465",
      "cy": "98",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M465.244 159.489C499.069 159.489 526.489 132.069 526.489 98.2444C526.489 64.4201 499.069 37 465.244 37C431.42 37 404 64.4201 404 98.2444C404 132.069 431.42 159.489 465.244 159.489Z",
      "stroke": "white",
      "stroke-width": "6.10619",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M465 160C499.242 160 527 132.242 527 98C527 63.7583 499.242 36 465 36C430.758 36 403 63.7583 403 98C403 132.242 430.758 160 465 160Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M465 160C499.242 160 527 132.242 527 98C527 63.7583 499.242 36 465 36C430.758 36 403 63.7583 403 98C403 132.242 430.758 160 465 160Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M490.972 126.507H487.568C485.854 126.507 484.208 126.507 482.71 126.507H476.962C473.926 126.507 471.519 125.259 471.519 120.975C471.519 115.763 472.718 113.931 476.284 113.577C477.596 113.445 478.917 113.621 480.214 113.872C482.223 114.26 484.228 114.55 486.237 114.909C488.3 115.277 490.383 115.606 492.486 115.601C495.688 115.591 498.877 114.825 501.564 113.042C505.867 110.188 508.515 105.265 508.515 100.098V96.5114C508.515 93.1857 505.076 90.6558 501.539 92.3162C498.38 93.7948 499.776 97.7395 497.683 99.8568C496.013 101.547 492.933 101.709 491.154 100.078C489.479 98.5452 490.073 96.0595 489.032 94.2026C487.121 90.8032 481.6 91.1225 480.455 95.0033C480.17 95.9661 480.219 96.9978 479.939 97.9606C479.335 100.034 477.267 101.355 475.145 101.208C473.926 101.124 472.742 100.554 471.951 99.6259C471.22 98.7711 470.846 97.656 470.704 96.5409C470.429 94.3843 470.822 91.5646 472.271 89.8354C474.398 87.2957 479.03 87.0157 481.452 87.0157H487.116C490.422 87.0157 493.104 84.3335 493.104 81.0274V73.1675C493.104 69.2719 489.047 66.5651 485.721 68.6235C482.779 70.446 483.992 74.9016 481.354 77.2546C476.815 81.3074 470.66 76.896 470.198 73.0496C469.372 66.1623 475.837 68.6922 480.096 66.2262C481.545 65.3911 482.233 64.0549 482.164 61.353C482.13 59.953 481.865 55.7479 481.865 55.7479C481.865 52.1717 478.962 50.9386 476.677 51.5036C475.12 51.8867 474.383 53.164 474.236 54.5002L473.98 56.9122C473.853 58.101 472.762 58.9901 471.578 58.887C470.041 58.7494 469.618 57.7129 469.363 56.2981C469.171 55.2469 468.999 50.8257 468.862 49.4747C468.68 47.7063 467.142 45.9329 464.995 45.9329C462.849 45.9329 461.311 47.7063 461.129 49.4747C460.992 50.8207 460.82 55.2469 460.628 56.2981C460.368 57.7129 459.95 58.7494 458.413 58.887C457.229 58.9901 456.138 58.101 456.011 56.9122L455.755 54.5002C455.608 53.164 454.871 51.8867 453.314 51.5036C451.029 50.9386 448.126 52.1717 448.126 55.7479C448.126 55.7479 447.861 59.9481 447.826 61.353C447.758 64.0549 448.445 65.3911 449.895 66.2262C454.154 68.6873 460.618 66.1623 459.793 73.0496C459.331 76.896 453.176 81.3074 448.637 77.2546C445.999 74.9016 447.212 70.446 444.27 68.6235C440.944 66.5602 436.886 69.267 436.886 73.1675V81.0274C436.886 84.3335 439.569 87.0157 442.875 87.0157H448.539C450.961 87.0157 455.593 87.2957 457.72 89.8354C459.169 91.5646 459.562 94.3843 459.287 96.5409C459.145 97.656 458.771 98.7711 458.039 99.6259C457.249 100.554 456.065 101.124 454.846 101.208C452.724 101.355 450.656 100.029 450.052 97.9606C449.772 96.9978 449.821 95.9661 449.536 95.0033C448.391 91.1225 442.87 90.8032 440.959 94.2026C439.917 96.0595 440.507 98.5403 438.837 100.078C437.058 101.709 433.978 101.547 432.308 99.8568C430.215 97.7346 431.61 93.7948 428.452 92.3162C424.915 90.6558 421.476 93.1857 421.476 96.5114V100.098C421.476 105.265 424.124 110.183 428.427 113.042C431.114 114.825 434.302 115.596 437.505 115.601C439.608 115.606 441.691 115.277 443.754 114.909C445.763 114.55 447.768 114.26 449.777 113.872C451.074 113.621 452.395 113.445 453.707 113.577C457.278 113.931 458.472 115.763 458.472 120.975C458.472 125.264 456.065 126.507 453.029 126.507H447.281C445.783 126.507 444.137 126.507 442.423 126.507H439.018C430.481 126.497 421.569 126.463 421.393 126.463C430.692 140.674 446.736 150.072 464.991 150.072C483.245 150.072 499.289 140.674 508.589 126.463C508.412 126.463 499.5 126.492 490.968 126.507H490.972Z",
      "fill": "#FAFAF4"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_b_3311_23977",
      "x": "-190",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_23977"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_23977",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint0_linear_3324_24193)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 141C112.242 141 140 113.242 140 79C140 44.7583 112.242 17 78 17C43.7583 17 16 44.7583 16 79C16 113.242 43.7583 141 78 141Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 141C112.242 141 140 113.242 140 79C140 44.7583 112.242 17 78 17C43.7583 17 16 44.7583 16 79C16 113.242 43.7583 141 78 141Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M103.972 107.507H100.568C98.8537 107.507 97.208 107.507 95.7097 107.507H89.9622C86.9263 107.507 84.5192 106.259 84.5192 101.975C84.5192 96.7631 85.7178 94.9307 89.2843 94.577C90.5959 94.4444 91.9173 94.6212 93.2142 94.8718C95.2234 95.2598 97.2277 95.5497 99.2369 95.9083C101.3 96.2767 103.383 96.6059 105.486 96.601C108.688 96.5911 111.877 95.8248 114.564 94.0416C118.867 91.1874 121.515 86.2652 121.515 81.0973V77.5112C121.515 74.1854 118.076 71.6555 114.539 73.316C111.38 74.7946 112.776 78.7393 110.683 80.8565C109.013 82.5464 105.933 82.7085 104.154 81.0776C102.479 79.5449 103.073 77.0592 102.032 75.2023C100.121 71.8029 94.5995 72.1222 93.4549 76.0031C93.17 76.9659 93.2191 77.9975 92.9391 78.9604C92.3349 81.0334 90.2667 82.3548 88.1446 82.2075C86.9263 82.124 85.7424 81.5541 84.9515 80.6257C84.2195 79.7709 83.8462 78.6558 83.7037 77.5406C83.4286 75.3841 83.8216 72.5643 85.2708 70.8352C87.3979 68.2954 92.0303 68.0154 94.4521 68.0154H100.116C103.422 68.0154 106.104 65.3332 106.104 62.0271V54.1672C106.104 50.2717 102.047 47.5649 98.7211 49.6232C95.7785 51.4457 96.9919 55.9013 94.3539 58.2544C89.8148 62.3072 83.6595 57.8958 83.1977 54.0493C82.3724 47.1621 88.8372 49.692 93.0963 47.2259C94.5455 46.3908 95.2332 45.0546 95.1645 42.3528C95.1301 40.9528 94.8648 36.7477 94.8648 36.7477C94.8648 33.1714 91.9615 31.9384 89.6772 32.5033C88.12 32.8865 87.3831 34.1637 87.2358 35.4999L86.9803 37.9119C86.8526 39.1008 85.762 39.9899 84.5781 39.8867C83.0405 39.7492 82.6181 38.7127 82.3626 37.2979C82.171 36.2466 81.9991 31.8254 81.8616 30.4745C81.6798 28.706 80.1422 26.9326 77.9955 26.9326C75.8487 26.9326 74.3111 28.706 74.1294 30.4745C73.9918 31.8205 73.8199 36.2466 73.6283 37.2979C73.3679 38.7127 72.9504 39.7492 71.4128 39.8867C70.2289 39.9899 69.1383 39.1008 69.0106 37.9119L68.7551 35.4999C68.6078 34.1637 67.8709 32.8865 66.3137 32.5033C64.0294 31.9384 61.1261 33.1714 61.1261 36.7477C61.1261 36.7477 60.8608 40.9478 60.8265 42.3528C60.7577 45.0546 61.4454 46.3908 62.8946 47.2259C67.1537 49.6871 73.6185 47.1621 72.7932 54.0493C72.3314 57.8958 66.1761 62.3072 61.637 58.2544C58.999 55.9013 60.2124 51.4457 57.2698 49.6232C53.9441 47.56 49.8864 50.2667 49.8864 54.1672V62.0271C49.8864 65.3332 52.5686 68.0154 55.8747 68.0154H61.5388C63.9606 68.0154 68.593 68.2954 70.7201 70.8352C72.1693 72.5643 72.5623 75.3841 72.2872 77.5406C72.1447 78.6558 71.7714 79.7709 71.0394 80.6257C70.2485 81.5541 69.0646 82.124 67.8463 82.2075C65.7242 82.3548 63.656 81.0285 63.0518 78.9604C62.7718 77.9975 62.8209 76.9659 62.536 76.0031C61.3914 72.1222 55.8698 71.8029 53.9589 75.2023C52.9174 77.0592 53.5069 79.54 51.8367 81.0776C50.0584 82.7085 46.9783 82.5464 45.308 80.8565C43.2153 78.7344 44.6105 74.7946 41.4518 73.316C37.9148 71.6555 34.4761 74.1854 34.4761 77.5112V81.0973C34.4761 86.2652 37.1239 91.1825 41.4272 94.0416C44.1143 95.8248 47.3025 96.596 50.5054 96.601C52.6079 96.6059 54.6908 96.2767 56.754 95.9083C58.7632 95.5497 60.7675 95.2598 62.7767 94.8718C64.0736 94.6212 65.395 94.4444 66.7067 94.577C70.278 94.9307 71.4717 96.7631 71.4717 101.975C71.4717 106.264 69.0646 107.507 66.0287 107.507H60.2812C58.7829 107.507 57.1372 107.507 55.4228 107.507H52.0184C43.4806 107.497 34.5694 107.462 34.3926 107.462C43.6918 121.674 59.7359 131.072 77.9905 131.072C96.2452 131.072 112.289 121.674 121.589 107.462C121.412 107.462 112.5 107.492 103.968 107.507H103.972Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "-2",
      "y": "-1",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', {
    ref: "creating",
    staticClass: "group pointer-events-none"
  }, [_c('svg', {
    staticClass: "pointer-events-none opacity-0 group-hover:opacity-100 ease-in-out duration-200",
    attrs: {
      "width": "575",
      "height": "204",
      "viewBox": "0 0 575 204",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "y": "596",
      "x": "-390"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_d_3311_24007)"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter1_b_3311_24007)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 98C4 43.8761 47.8761 0 102 0H473C527.124 0 571 43.8761 571 98C571 152.124 527.124 196 473 196H102C47.8761 196 4 152.124 4 98Z",
      "fill": "#101327",
      "fill-opacity": "0.8"
    }
  })]), _vm._v(" "), _c('text', {
    staticClass: "text-xl-semibold",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "66",
      "y": "61"
    }
  }, [_vm._v("CREATING CONNECTIONS")])]), _vm._v(" "), _c('text', {
    staticClass: "text-base-regular",
    attrs: {
      "fill": "white"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "66",
      "y": "90"
    }
  }, [_vm._v("\n                        Building bridges across the community\n                      ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "66",
      "y": "114"
    }
  }, [_vm._v("\n                        with thoughtful networking and\n                      ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "66",
      "y": "138"
    }
  }, [_vm._v("professional match-making.")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "469",
      "cy": "98",
      "r": "77",
      "stroke": "white",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M469.245 159.49C503.07 159.49 530.49 132.07 530.49 98.245C530.49 64.4203 503.07 37 469.245 37C435.42 37 408 64.4203 408 98.245C408 132.07 435.42 159.49 469.245 159.49Z",
      "stroke": "#FAFAF4",
      "stroke-width": "6.11",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M469.245 159.49C503.07 159.49 530.49 132.07 530.49 98.245C530.49 64.4203 503.07 37 469.245 37C435.42 37 408 64.4203 408 98.245C408 132.07 435.42 159.49 469.245 159.49Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M507.49 77.2331C507.49 75.8501 506.917 74.4622 505.777 73.4626C503.768 71.7011 500.682 71.9583 498.794 73.8508L486.532 86.1134C485.881 86.7637 484.828 86.7637 484.183 86.1134L484.028 85.9581C483.377 85.3079 483.377 84.2548 484.028 83.6094L486.231 81.4064L486.43 81.2074L502.065 65.5722C503.04 64.5969 503.53 63.3158 503.53 62.0347C503.53 60.6517 502.958 59.2638 501.817 58.2642C499.808 56.5027 496.727 56.7599 494.839 58.6475L477.972 75.5153C477.321 76.1655 476.268 76.1655 475.623 75.5153L475.468 75.36C474.817 74.7097 474.817 73.6567 475.468 73.0113L488.715 59.7636C489.691 58.7883 490.181 57.5072 490.181 56.2261C490.181 54.8431 489.608 53.4552 488.468 52.4556C486.459 50.6941 483.373 50.9513 481.485 52.8389L470.314 64.0097L466.757 67.5667L457.052 77.2719C456.499 77.8251 455.591 77.9319 454.985 77.4369C454.286 76.8643 454.247 75.8307 454.868 75.2095L462.574 67.5036C464.646 65.4315 464.646 62.0638 462.574 59.9917C460.502 57.9196 457.134 57.9196 455.062 59.9917L445.483 69.5708C445.483 69.5708 446.444 68.6148 446.425 68.6342C437.122 78.0629 436.705 92.9556 445.168 102.879L432.473 115.574C431.498 116.549 431.008 117.83 431.008 119.111C431.008 120.494 431.58 121.882 432.721 122.882C434.73 124.643 437.816 124.386 439.704 122.494L451.966 110.231C452.617 109.581 453.67 109.581 454.315 110.231L454.47 110.386C455.121 111.036 455.121 112.09 454.47 112.735L452.267 114.938L452.068 115.137L436.433 130.772C435.458 131.747 434.968 133.029 434.968 134.31C434.968 135.693 435.54 137.081 436.681 138.08C438.69 139.842 441.771 139.584 443.659 137.697L460.526 120.829C461.177 120.179 462.23 120.179 462.875 120.829L463.03 120.984C463.681 121.635 463.681 122.688 463.03 123.333L449.783 136.581C448.807 137.556 448.317 138.837 448.317 140.118C448.317 141.501 448.89 142.889 450.03 143.889C452.039 145.65 455.125 145.393 457.013 143.505L468.184 132.335L471.741 128.778L481.446 119.072C481.999 118.519 482.907 118.412 483.513 118.907C484.212 119.48 484.251 120.514 483.63 121.135L475.924 128.841C473.852 130.913 473.852 134.281 475.924 136.353C477.996 138.425 481.364 138.425 483.436 136.353L493.015 126.774C493.015 126.774 492.054 127.73 492.073 127.71C501.376 118.281 501.793 103.389 493.33 93.4651L506.025 80.7707C507 79.7953 507.49 78.5142 507.49 77.2331ZM469.247 111.036C462.186 111.036 456.46 105.31 456.46 98.2498C456.46 91.1892 462.186 85.4632 469.247 85.4632C476.307 85.4632 482.033 91.1892 482.033 98.2498C482.033 105.31 476.307 111.036 469.247 111.036Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_3311_24007",
      "x": "0",
      "y": "0",
      "width": "575",
      "height": "204",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "4"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "2"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_3311_24007"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_3311_24007",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_b_3311_24007",
      "x": "-186",
      "y": "-190",
      "width": "947",
      "height": "576",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "BackgroundImageFix",
      "stdDeviation": "95"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceAlpha",
      "operator": "in",
      "result": "effect1_backgroundBlur_3311_24007"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_backgroundBlur_3311_24007",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('g', {
    staticClass: "ease-in-out duration-200 opacity-100 group-hover:opacity-0",
    staticStyle: {
      "mix-blend-mode": "overlay"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint1_linear_3324_24193)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 756C112.242 756 140 728.242 140 694C140 659.758 112.242 632 78 632C43.7583 632 16 659.758 16 694C16 728.242 43.7583 756 78 756Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78 756C112.242 756 140 728.242 140 694C140 659.758 112.242 632 78 632C43.7583 632 16 659.758 16 694C16 728.242 43.7583 756 78 756Z",
      "stroke": "#FAFAF4",
      "stroke-width": "3",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M116.716 672.729C116.716 671.329 116.136 669.924 114.982 668.912C112.948 667.129 109.824 667.389 107.913 669.305L95.4992 681.719C94.841 682.377 93.775 682.377 93.1216 681.719L92.9644 681.562C92.3062 680.904 92.3062 679.838 92.9644 679.184L95.1947 676.954L95.3961 676.752L111.224 660.925C112.211 659.937 112.708 658.64 112.708 657.343C112.708 655.943 112.128 654.538 110.973 653.526C108.94 651.743 105.82 652.004 103.909 653.915L86.8337 670.99C86.1754 671.648 85.1094 671.648 84.4561 670.99L84.2989 670.833C83.6406 670.175 83.6406 669.109 84.2989 668.455L97.7098 655.044C98.6972 654.057 99.1934 652.76 99.1934 651.463C99.1934 650.063 98.6137 648.658 97.4593 647.646C95.4255 645.863 92.3012 646.123 90.3903 648.034L79.0818 659.343L75.481 662.944L65.6561 672.768C65.0961 673.329 64.1775 673.437 63.5634 672.936C62.856 672.356 62.8167 671.31 63.4455 670.681L71.2465 662.88C73.3441 660.782 73.3441 657.373 71.2465 655.275C69.1489 653.178 65.7396 653.178 63.642 655.275L53.9448 664.972C53.9448 664.972 54.9175 664.005 54.8979 664.024C45.4807 673.569 45.0582 688.646 53.6255 698.691L40.7746 711.542C39.7872 712.53 39.291 713.827 39.291 715.124C39.291 716.524 39.8707 717.929 41.0251 718.941C43.0589 720.724 46.1832 720.463 48.0941 718.548L60.5079 706.134C61.1661 705.476 62.2321 705.476 62.8855 706.134L63.0427 706.291C63.701 706.949 63.701 708.015 63.0427 708.669L60.8124 710.899L60.611 711.1L44.7831 726.928C43.7957 727.916 43.2996 729.213 43.2996 730.509C43.2996 731.909 43.8792 733.314 45.0337 734.326C47.0674 736.11 50.1868 735.849 52.0978 733.938L69.1734 716.863C69.8317 716.204 70.8977 716.204 71.5511 716.863L71.7083 717.02C72.3665 717.678 72.3665 718.744 71.7083 719.397L58.2973 732.808C57.3099 733.796 56.8137 735.093 56.8137 736.39C56.8137 737.79 57.3934 739.195 58.5478 740.207C60.5816 741.99 63.7059 741.729 65.6168 739.818L76.9253 728.51L80.5261 724.909L90.351 715.084C90.911 714.524 91.8297 714.416 92.4437 714.917C93.1511 715.497 93.1904 716.543 92.5616 717.172L84.7606 724.973C82.663 727.071 82.663 730.48 84.7606 732.578C86.8582 734.675 90.2675 734.675 92.3651 732.578L102.062 722.88C102.062 722.88 101.09 723.848 101.109 723.828C110.526 714.284 110.949 699.207 102.382 689.161L115.233 676.31C116.22 675.323 116.716 674.026 116.716 672.729ZM78.0011 706.949C70.8535 706.949 65.0568 701.153 65.0568 694.005C65.0568 686.857 70.8535 681.061 78.0011 681.061C85.1487 681.061 90.9454 686.857 90.9454 694.005C90.9454 701.153 85.1487 706.949 78.0011 706.949Z",
      "fill": "#FAFAF4"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "overflow-visible outer-ring opacity-0 group-hover:opacity-0 pointer-events-none",
    attrs: {
      "x": "-2",
      "y": "616",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "outer-ring-path",
    attrs: {
      "d": "M79 157C122.078 157 157 122.078 157 79C157 35.9218 122.078 1 79 1C35.9218 1 1 35.9218 1 79C1 122.078 35.9218 157 79 157Z",
      "stroke": "#FAFAF4",
      "stroke-miterlimit": "10"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$afterImages1 = _vm.blok.afterImages) !== null && _vm$blok$afterImages1 !== void 0 && _vm$blok$afterImages1[5] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages10 = _vm.blok.afterImages) === null || _vm$blok$afterImages10 === void 0 ? void 0 : _vm$blok$afterImages10[5]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$afterImages11 = _vm.blok.afterImages) !== null && _vm$blok$afterImages11 !== void 0 && _vm$blok$afterImages11[6] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$afterImages12 = _vm.blok.afterImages) === null || _vm$blok$afterImages12 === void 0 ? void 0 : _vm$blok$afterImages12[6]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3324_24193",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3324_24193",
      "x1": "36.957",
      "y1": "173.025",
      "x2": "-23.0206",
      "y2": "-54.4829",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4BA9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.160254",
      "stop-color": "#327BB6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.462557",
      "stop-color": "#93DCC9"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#BFDDF1"
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "absolute h-full w-full text-black flex justify-center items-end z-30"
  }, [_c('div', {
    staticClass: "h-1/2 w-full grid grid-cols-3 overflow-hidden",
    style: {
      placeItems: 'start end'
    }
  }, [_c('div', {
    staticClass: "RechargeDifference--before flex justify-end",
    style: {
      willChange: 'transform'
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1200",
      "viewBox": "0 0 156 1200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint0_linear_3328_24238)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint1_linear_3328_24238)"
    }
  }), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_3328_24238",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "804",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "url(#pattern0)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_3328_24238)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-62",
      "y": "777",
      "width": "280",
      "height": "427",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-62",
      "y": "777",
      "width": "280",
      "height": "427",
      "fill": "url(#pattern1)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69",
      "y": "788",
      "width": "315",
      "height": "413",
      "fill": "url(#pattern2)"
    }
  })])]), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask1_3328_24238",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "188",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "url(#pattern3)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask1_3328_24238)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-183.191",
      "y": "182",
      "width": "560.384",
      "height": "373.699",
      "fill": "url(#pattern4)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69",
      "y": "125",
      "width": "315",
      "height": "460",
      "fill": "url(#pattern5)"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$beforeImages = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages !== void 0 && _vm$blok$beforeImages[0] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages2 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages2 === void 0 ? void 0 : _vm$blok$beforeImages2[0]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$beforeImages3 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages3 !== void 0 && _vm$blok$beforeImages3[1] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages4 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages4 === void 0 ? void 0 : _vm$blok$beforeImages4[1]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern2",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern3",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern4",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern5",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3328_24238",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3328_24238",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "RechargeDifference--before flex justify-end",
    style: {
      willChange: 'transform'
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1816",
      "viewBox": "0 0 156 1816",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint0_linear_3338_23864)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 1388)",
      "fill": "url(#paint1_linear_3338_23864)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint2_linear_3338_23864)"
    }
  }), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_3338_23864",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "804",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "url(#pattern0)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_3338_23864)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-54",
      "y": "804",
      "width": "264",
      "height": "396",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-54",
      "y": "804",
      "width": "264",
      "height": "396",
      "fill": "url(#pattern1)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69.0977",
      "y": "965.82",
      "width": "315.041",
      "height": "235.375",
      "fill": "url(#pattern2)"
    }
  })])]), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask1_3338_23864",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "188",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "url(#pattern3)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask1_3338_23864)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-3",
      "y": "188",
      "width": "167",
      "height": "398",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-3",
      "y": "188",
      "width": "167",
      "height": "398",
      "fill": "url(#pattern4)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69",
      "y": "95",
      "width": "315",
      "height": "490",
      "fill": "url(#pattern5)"
    }
  })])]), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask2_3338_23864",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "1420",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 1498C0 1454.92 34.9218 1420 78 1420C121.078 1420 156 1454.92 156 1498V1738C156 1781.08 121.078 1816 78 1816C34.9218 1816 0 1781.08 0 1738V1498Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 1498C0 1454.92 34.9218 1420 78 1420C121.078 1420 156 1454.92 156 1498V1738C156 1781.08 121.078 1816 78 1816C34.9218 1816 0 1781.08 0 1738V1498Z",
      "fill": "url(#pattern6)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask2_3338_23864)"
    }
  }, [_c('rect', {
    attrs: {
      "width": "268",
      "height": "402",
      "transform": "matrix(-1 0 0 1 227 1414)",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "width": "268",
      "height": "402",
      "transform": "matrix(-1 0 0 1 227 1414)",
      "fill": "url(#pattern7)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69.0977",
      "y": "1581.82",
      "width": "315.041",
      "height": "235.375",
      "fill": "url(#pattern8)"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$beforeImages5 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages5 !== void 0 && _vm$blok$beforeImages5[2] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages6 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages6 === void 0 ? void 0 : _vm$blok$beforeImages6[2]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$beforeImages7 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages7 !== void 0 && _vm$blok$beforeImages7[3] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages8 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages8 === void 0 ? void 0 : _vm$blok$beforeImages8[3]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$beforeImages9 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages9 !== void 0 && _vm$blok$beforeImages9[4] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages0 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages0 === void 0 ? void 0 : _vm$blok$beforeImages0[4]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern2",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern3",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern4",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern5",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern6",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern7",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern8",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3338_23864",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3338_23864",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_3338_23864",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "RechargeDifference--before flex justify-end",
    style: {
      willChange: 'transform'
    }
  }, [_c('svg', {
    staticClass: "pointer-events-auto w-2/3 lg:w-4/5 xl:w-full",
    attrs: {
      "width": "156",
      "height": "1200",
      "viewBox": "0 0 156 1200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 156)",
      "fill": "url(#paint0_linear_3341_23865)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "78",
      "cy": "78",
      "r": "78",
      "transform": "matrix(1 0 0 -1 0 772)",
      "fill": "url(#paint1_linear_3341_23865)"
    }
  }), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_3341_23865",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "188",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 266C0 222.922 34.9218 188 78 188C121.078 188 156 222.922 156 266V506C156 549.078 121.078 584 78 584C34.9218 584 0 549.078 0 506V266Z",
      "fill": "url(#pattern0)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask0_3341_23865)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-79",
      "y": "183",
      "width": "301",
      "height": "401",
      "fill": "url(#pattern1)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "opacity": "0.2",
      "x": "-69",
      "y": "121",
      "width": "315",
      "height": "464",
      "fill": "url(#pattern2)"
    }
  })])]), _vm._v(" "), _c('g', {
    staticStyle: {
      "mix-blend-mode": "luminosity"
    },
    attrs: {
      "opacity": "0.9"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask1_3341_23865",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "804",
      "width": "156",
      "height": "396"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "#727272"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 882C0 838.922 34.9218 804 78 804C121.078 804 156 838.922 156 882V1122C156 1165.08 121.078 1200 78 1200C34.9218 1200 0 1165.08 0 1122V882Z",
      "fill": "url(#pattern3)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#mask1_3341_23865)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "-184.191",
      "y": "878",
      "width": "560.384",
      "height": "373.699",
      "fill": "url(#pattern4)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-102",
      "y": "795",
      "width": "290",
      "height": "436",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-102",
      "y": "795",
      "width": "290",
      "height": "436",
      "fill": "url(#pattern5)"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-68",
      "y": "804",
      "width": "276",
      "height": "396",
      "fill": "#D9D9D9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "-68",
      "y": "804",
      "width": "276",
      "height": "396",
      "fill": "url(#pattern6)"
    }
  })])]), _vm._v(" "), _c('g', [(_vm$blok$beforeImages1 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages1 !== void 0 && _vm$blok$beforeImages1[5] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages10 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages10 === void 0 ? void 0 : _vm$blok$beforeImages10[5]
    }
  }) : _vm._e(), _vm._v(" "), (_vm$blok$beforeImages11 = _vm.blok.beforeImages) !== null && _vm$blok$beforeImages11 !== void 0 && _vm$blok$beforeImages11[6] ? _c('StoryblokComponent', {
    attrs: {
      "blok": (_vm$blok$beforeImages12 = _vm.blok.beforeImages) === null || _vm$blok$beforeImages12 === void 0 ? void 0 : _vm$blok$beforeImages12[6]
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern1",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern2",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern3",
      "patternContentUnits": "objectBoundingBox",
      "width": "15.4502",
      "height": "6.08646"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern4",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern5",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "pattern6",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint0_linear_3341_23865",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_3341_23865",
      "x1": "77.9983",
      "y1": "-0.896783",
      "x2": "77.9983",
      "y2": "187.529",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#4B4B93"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#327BA0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.61",
      "stop-color": "#80C6B3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.86",
      "stop-color": "#A9C7DB"
    }
  })], 1)], 1)])])])])]) : _c('aside', {
    staticClass: "w-4/5 hidden md:block"
  }, [(_vm$blok$staticImage = _vm.blok.staticImage) !== null && _vm$blok$staticImage !== void 0 && _vm$blok$staticImage.length ? _c('StoryblokComponent', {
    attrs: {
      "blok": _vm.blok.staticImage[0]
    }
  }) : _vm._e()], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }